import { BasicModal, ShowModal } from '../components/Modal';
import Box from '@mui/material/Box';
// @ts-ignore
import { Autocomplete, Popover, Select, InputLabel, MenuItem, FormControl, Typography, Button, Tooltip, Dialog, Card, CardContent, Grid, Divider, Tabs, Tab, TextField, Checkbox, styled, List, ListItem, Paper, Avatar, NativeSelect, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, FormControlLabel, Switch } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import IconButton from '@mui/material/IconButton';
import { NoData } from '../components/NoData';
import Barcode from 'react-barcode';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import { colors } from 'styles/colors';
import MuiInput from '@mui/material/Input';
// @ts-ignore
import qrcode from '../images/others/qrcode.png';
import { IMaskInput } from 'react-imask';
import SaveIcon from '@mui/icons-material/Save';
import React from 'react';
import { TechSpecif } from 'components/TechSpecif';
import { AddQrCode } from 'components/AddQrcode';
import { ChooseProducts } from 'components/ChooseProducts';
import QrCodeIcon from '@mui/icons-material/QrCode';
import NoPhoto from '../images/others/noPhoto.png';
import { useReactToPrint } from 'react-to-print';
import Loading from 'components/Load';
import { ReportTable } from 'components/reportTable';
// @ts-ignore
import { useMutation } from 'react-query';
import { getDataSource } from 'api/ds';
import { delFts, get, getFile, post } from 'api/apiBridges/httpBridge';
import { getDocument } from 'pdfjs-dist';
// @ts-ignore
import { createRoot } from 'react-dom/client';
import { SocketContext } from 'components/socketLib/ConnectorSocket';
import { TabPanel } from 'components/tabPanel';
// @ts-ignore
import SearchIcon from '@mui/icons-material/Search';
// @ts-ignore
import CloseIcon from '@mui/icons-material/Close';
import EAC from '../images/others/EAC.png'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ListAltIcon from '@mui/icons-material/ListAlt';
// import UnarchiveIcon from '@mui/icons-material/Unarchive';
import boxImg from '../images/others/boxImage.png'
// @ts-ignore
import { CircularProgressWithLabel, LinearProgressWithLabel } from 'components/ProgressBar';
import Scrollbars from 'rc-scrollbars';
import { pastelColors } from 'components/pastelColors';
import { useSelector } from 'react-redux';
import { loginSelector } from 'store/slices/loginSlice';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// @ts-ignore
import { urPK } from '@mui/x-date-pickers/locales';
import ClassicSearch from 'components/classicSearch';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import AddIcon from '@mui/icons-material/Add';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CheckIcon from '@mui/icons-material/Check';
import ListIcon from '@mui/icons-material/List';
import { MarketClientSelector } from "store/slices/marketClient";
import _ from 'lodash';
import { useLocalNotifications } from "components/Events";
import UserAvatar from 'components/EIComponents/UserAvatar';
import { CancelButton, NumInput, NumInputDesign, OKButton } from 'components/EIComponents/LittleComponents';
import InfoIcon from '@mui/icons-material/Info';
import ReplayIcon from '@mui/icons-material/Replay';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
// import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import defectIcon from '../images/others/defectIcon.png'
import { ImgMagazine } from 'components/SelectMarket';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { SemiCircleProgress } from 'react-semicircle-progressbar';
import { buttonColor, buttonColorHover, errorTextColor, hoverStyle, successTextColor, warningTextColor } from "styles/main";
import usePreventDoubleClick from 'components/AntiDBC';
import { formatGS1Code, scanPageForKiz } from 'components/KIZFunctions';
import ExcelJS from 'exceljs';

// отображение уменьшенного изображения
const ImageClose = ({ img }) => {

    return (<Box sx={{
        '&:hover': {
            cursor: 'pointer'
        }
    }} ><img alt="" src={img || NoPhoto} style={{backgroundSize: 'cover', marginRight: '10px', borderRadius: "5px" }} width={70} height={105}></img></Box>);

}

// отображение уменьшенного изображения
const ImageCloseSmall = ({ img }) => {

    return (<Box sx={{
        '&:hover': {
            cursor: 'pointer'
        }
    }} ><img alt="" src={img || NoPhoto} style={{backgroundSize: 'cover', marginRight: '10px', borderRadius: "5px" }} width={24} height={35}></img></Box>);

}

// отображение увеличенного изображения
const ImageOpen = ({ img }) => {
    return (<img alt="" src={img || NoPhoto} style={{ border: '1px solid black', backgroundSize: 'cover' }} width={350} height={525}></img>);
}

// отображение изображения в модальном окне
export function ImageFormatProduct({ value }) {
    return (
        <BasicModal childOpen={<ImageOpen img={value}></ImageOpen>} childClose={<ImageClose img={value}></ImageClose>}></BasicModal>
    );
}


// отображение изображения в модальном окне
function LittleImageFormatProduct({ value }) {
    return (
        <BasicModal childOpen={<ImageOpen img={value}></ImageOpen>} childClose={<ImageCloseSmall img={value}></ImageCloseSmall>}></BasicModal>
    );
}

// отображение большого кол-ва текста
function MoreTextFormat({ value }) {
    if (value) {
        return (
            <div style={{ overflow: 'auto', textAlign: 'start', width: '100%' }}>
                <p style={{ wordBreak: 'break-word' }}>{value}</p>
            </div>
        );
    } else {
        return (
            <NoData></NoData>
        );
    }
}

// отображение выбора формата
function SelectFormat({ value, desc }) {
    // console.log('SelectFormat', value, desc);
    if (value) {
        return (
            <div style={{ boxSizing: 'border-box' }}>
                <FormControl sx={{ minWidth: 100 }} size="small">
                    <InputLabel htmlFor="grouped-select">{desc?.title || desc?.id}</InputLabel>
                    <Select defaultValue={value} id="grouped-select" label="Grouping" >
                        {desc?.select.map(($val) =>
                            <MenuItem value={$val}>{$val}</MenuItem>
                        )}
                    </Select>
                </FormControl>
            </div>
        );
    } else {
        return (
            <NoData></NoData>
        );
    }
}
//ЛИЗА, вообще правильно, но тут как бужто можно было прописать их в компонент BarCode и использовать уже его напрямую, хотя хз
// добавила сюда параметры для штрих-кода, чтобы не менять их во всех местах по отдельности
const barcode_width = 1
const barcode_height = 33
const barcode_fontsize = 17
const barcode_textmargin = 2


// отображение штрих кода в выдвижном элементе
// const AccordionItemBarcode = ({ child, data }) => {

//     // console.log("BARCOE", data)
//     const [active, setActive] = useState(false);

//     const handleItemClick = () => {
//         setActive(!active);
//     };
//     const contentHeight = useRef()
//     return (
//         <div className="wrapper" >
//             <div className="answer-content" onClick={handleItemClick}>{child}</div>
//             <div ref={contentHeight} className="answer-container" style={
//                 active
//                     // @ts-ignore
//                     ? { height: contentHeight.current.scrollHeight }
//                     : { height: "0px" }
//             }>
//                 <div style={{ display: 'flex', flexDirection: 'column' }}>
//                     {Object.keys(data).map((el) =>
//                         <span>{`${el}: ${data[el]}`}</span>
//                     )}
//                 </div>
//             </div>
//         </div>
//     )
// }

// отображение штрих кода
const BarCode = ({ value }) => { //РЕДАЧИМ
    if (value){
    return (
        <Box sx={{
            width:'100%',
            display:'flex',
            flexDirection: 'column',
            alignItems: 'center',
            '&:hover': {
                cursor: 'pointer'
            }
        }} >
            {value.barcode? <Barcode format='CODE128' value={value.barcode} width={barcode_width} height={barcode_height} fontSize={barcode_fontsize} textMargin={barcode_textmargin} />: <></>}
            {value.newMarketBarcode && <Typography sx={{fontSize: 15, color: 'gray'}}>({value.newMarketBarcode})</Typography>}
            {/* <AccordionItemBarcode data={value} child={value.barcode? <Barcode format='CODE128' value={value.barcode} width={2} height={24} fontSize={14} textMargin={5} />: <></>}></AccordionItemBarcode> */}
        </Box>
    )}
}


const BarCodeChangable = ({ value, id, onChangeValue }) => { //РЕДАЧИМ
    if (value){
    return (
        <Box sx={{
            width:'100%',
            display:'flex',
            flexDirection: 'column',
            alignItems: 'center',
            '&:hover': {
                cursor: 'pointer'
            }
        }} >
            {value.barcode? <Barcode format='CODE128' value={value.barcode} width={barcode_width} height={barcode_height} fontSize={0} textMargin={barcode_textmargin} />: <></>}
            {/* <AccordionItemBarcode data={value} child={value.barcode? <Barcode format='CODE128' value={value.barcode} width={2} height={24} fontSize={14} textMargin={5} />: <></>}></AccordionItemBarcode> */}
            <BarcodeSelect barcode={value.barcode} barcodes={value.barcodes} onChange={(b) => {onChangeValue({...id, changeBarcode: b})}}/>
        </Box>
    )}
}

export const BarcodeSelect = ({
  barcode,
  barcodes,
  onChange,
  width = '150px',
  aline = 'center'
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [menuWidth, setMenuWidth] = useState(width);
  const selectRef = useRef(null);

  useEffect(() => {
    if (isOpen && selectRef.current) {
      // Получаем реальную ширину селекта и вычитаем 2 пикселя, чтобы компенсировать разницу из-за border
      const realWidth = selectRef.current.offsetWidth;
      setMenuWidth(realWidth - 0.5); // подберите значение: 1 или 2
    }
  }, [isOpen]);

  return (
    <div style={{ width:'100%', display: 'flex', justifyContent: aline, padding: "0px", margin: "0px"}} ref={selectRef}>
        {barcodes && barcodes.length>1 ?
            <FormControl fullWidth>
                <Select
                value={barcode}
                onChange={(e) => onChange(e.target.value)}
                open={isOpen}
                onOpen={() => setIsOpen(true)}
                onClose={() => setIsOpen(false)}
                variant="standard"
                disableUnderline
                sx={{
                    fontSize: 15,
                    '& .MuiSelect-select': {
                    transition: 'background-color 0.2s ease',
                    borderRadius: isOpen ? '10px 10px 0 0' : '10px',
                    padding: '6px 12px',
                    backgroundColor: isOpen ? '#ffffff' : 'transparent',
                    border: isOpen ? '1px solid #e0e0e0' : 'none',
                    borderBottom: isOpen ? 'none' : 'none',
                    // Важно, чтобы padding и border входили в общую ширину
                    boxSizing: 'border-box',
                    },
                    '&.Mui-focused .MuiSelect-select': {
                    backgroundColor: isOpen ? '#ffffff' : 'transparent',
                    borderRadius: isOpen ? '10px 10px 0 0' : '10px',
                    border: isOpen ? '1px solid #e0e0e0' : 'none',
                    borderBottom: isOpen ? 'none' : 'none',
                    },
                    '&:hover .MuiSelect-select': {
                    backgroundColor: isOpen ? '#ffffff' : '#d6ebec',
                    borderRadius: isOpen ? '10px 10px 0 0' : '10px',
                    border: isOpen ? '1px solid #e0e0e0' : 'none',
                    borderBottom: isOpen ? 'none' : 'none',
                    },
                    '& .MuiSelect-select.Mui-active': {
                    backgroundColor: isOpen ? '#ffffff' : 'transparent',
                    borderRadius: isOpen ? '10px 10px 0 0' : '10px',
                    border: isOpen ? '1px solid #e0e0e0' : 'none',
                    borderBottom: isOpen ? 'none' : 'none',
                    },
                    '& .MuiSelect-select:active': {
                    backgroundColor: isOpen ? '#ffffff' : 'transparent',
                    borderRadius: isOpen ? '10px 10px 0 0' : '10px',
                    border: isOpen ? '1px solid #e0e0e0' : 'none',
                    borderBottom: isOpen ? 'none' : 'none',
                    },
                }}
                MenuProps={{
                    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                    transformOrigin: { vertical: 'top', horizontal: 'left' },
                    PaperProps: {
                    style: {
                        width: menuWidth,
                        minWidth: 'auto',
                    },
                    sx: {
                        backgroundColor: '#ffffff',
                        boxShadow: 'none',
                        border: '1px solid #e0e0e0',
                        borderTop: 'none',
                        borderRadius: '0 0 10px 10px',
                        marginTop: '0px',
                        boxSizing: 'border-box',
                        '& .MuiList-root': {
                        padding: 0,
                        },
                        '& .MuiMenuItem-root': {
                        backgroundColor: 'transparent',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                        },
                    },
                    },
                }}
                renderValue={(selected) => (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span>{selected}</span>
                    </Box>
                )}
                >
                {barcodes.map((v) => (
                    <MenuItem key={v} value={v} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>{v}</span>
                    </MenuItem>
                ))}
                </Select>
            </FormControl>
        :
        <Typography sx={{fontSize: 15}}>{barcode}</Typography>
        } 
    </div>
  );
};

const BarcodeMappingCell = ({ value }) => {
    const { user_id } = useSelector(loginSelector);
    const { market } = useSelector(MarketClientSelector);
    const { baseBarcode, savedRecord } = value;
    const { showNotification } = useLocalNotifications();
    
    const [dialogConfig, setDialogConfig] = useState({
        isOpen: false,
        marketType: null,
        targetField: null
    });

    const [productsData, setProductsData] = useState([]);
    const [loading, setLoading] = useState(false);

    const ds_client = useMemo(() => getDataSource('ClientProducts'), []);

    const [codes, setCodes] = useState({
        wb_barcode: savedRecord?.wb_barcode || (market === 'wb' ? baseBarcode : ''),
        ozon_barcode: savedRecord?.ozon_barcode || (market === 'ozon' ? baseBarcode : ''),
        custom_barcode: savedRecord?.custom_barcode || (market === 'custom' ? baseBarcode : '')
    });

    const [savedRecordState, setSavedRecordState] = useState(savedRecord);

    useEffect(() => {
        if (!dialogConfig.marketType || !dialogConfig.isOpen) return;
        let isActive = true;

        const fetchData = async () => {
            try {
                setLoading(true);
                let responseData = [];
                if (dialogConfig.marketType === "wb") {
                    responseData = await ds_client.getWBCardAndStocks(user_id);
                }
                if (dialogConfig.marketType === "ozon") {
                    responseData = await ds_client.getOZONCardAndStocks(user_id);
                }
                if (dialogConfig.marketType === "custom") {
                    responseData = await get("custom_product/getOnCli", { cid: user_id });
                }
                if (isActive) {
                    setProductsData(responseData);
                }
            } catch (err) {
                console.error("Ошибка загрузки:", err);
            } finally {
                if (isActive) setLoading(false);
            }
        };
        fetchData();
        return () => {
            isActive = false;
        };
    }, [dialogConfig.marketType, dialogConfig.isOpen, user_id, ds_client]);

    const handleOpenDialog = (field, marketType) => {
        setProductsData([]);
        setDialogConfig({
            isOpen: true,
            marketType,
            targetField: field
        });
    };

    const handleBarcodeSelect = async (barcode) => {
    if (!dialogConfig.targetField) return;

    const updatedCodes = {
        ...codes,
        [dialogConfig.targetField]: barcode
    };
    setCodes(updatedCodes);
    setLoading(true);
    try {
        let response;
        if (savedRecordState?.id) {
            response = await post('Barcode_search/update', {
                id: savedRecordState.id,
                ...updatedCodes
            });
        } else {
            response = await post("Barcode_search/create", {
                user_id,
                ...updatedCodes
            });
        }

        setSavedRecordState({
            id: response.id || savedRecordState?.id,
            ...updatedCodes
        });

        showNotification({
            id: 'updateItems',
            type: 'success',
            message: 'Данные обновлены'
        });
    } catch (e) {
        console.error("Save error", e);
    } finally {
        setLoading(false);
    }
    setDialogConfig({
        isOpen: false,
        marketType: null,
        targetField: null
    });
};

    const changedFields = useMemo(() => {
        const initial = {
            wb_barcode: savedRecordState?.wb_barcode || (market === 'wb' ? baseBarcode : ''),
            ozon_barcode: savedRecordState?.ozon_barcode || (market === 'ozon' ? baseBarcode : ''),
            custom_barcode: savedRecordState?.custom_barcode || (market === 'custom' ? baseBarcode : '')
        };

        return {
            wb_barcode: codes.wb_barcode !== initial.wb_barcode,
            ozon_barcode: codes.ozon_barcode !== initial.ozon_barcode,
            custom_barcode: codes.custom_barcode !== initial.custom_barcode
        };
    }, [codes, savedRecordState, market, baseBarcode]);

    const hasChanges = Object.values(changedFields).some(Boolean);

    const renderTextField = (label, field) => (
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <TextField
                variant="outlined"
                size="medium"
                label={label}
                value={codes[field] || ''}
                InputProps={{
                    readOnly: true,
                    sx: {
                        cursor: 'default'
                    }
                }}
                inputProps={{
                    style: {
                        cursor: 'default'
                    }
                }}
                disabled={market === field.split('_')[0]}
            />

            <Button 
                variant="text" 
                size="small" 
                onClick={() => handleOpenDialog(field, field.split('_')[0])}
                disabled={market === field.split('_')[0]}
                sx={{ alignSelf: 'flex-start', color: '#208f84', textTransform: 'none' }}
            >
                Выбрать товар
            </Button>
        </Box>
    );

    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <Box sx={{ display: 'flex', gap: '10px', mt: 2 }}>
                    {renderTextField('WB', 'wb_barcode')}
                    {renderTextField('OZON', 'ozon_barcode')}
                    {renderTextField('Ваш МП', 'custom_barcode')}
                </Box>
            </div>

            <Dialog 
                open={dialogConfig.isOpen} 
                onClose={() => setDialogConfig({ isOpen: false, marketType: null, targetField: null })}
                maxWidth="lg"
                fullWidth
            >
                <Box sx={{ p: 1, height: '80vh' }}>
                    <ChooseProducts 
                        productsData={productsData} 
                        onSelect={handleBarcodeSelect}
                        onCancel={() => setDialogConfig({ isOpen: false, marketType: null, targetField: null })}
                        initialBarcode={codes[dialogConfig.targetField]}>
                    </ChooseProducts>
                </Box>
            </Dialog>
        </>
    );
};

// @ts-ignore
export const StyledTab = styled(Tab)(({ theme }) => ({
    alignItems: "center",
    textTransform: "none",
    color: 'black',
    borderRadius: "6px",
    transition: "all 0.2s ease-in-out",
    // Жирный шрифт
    fontWeight: 'bold',
    
    // Способ 1: Уменьшение высоты через minHeight
    minHeight: '20px', // вместо стандартных 48px
    
    // Способ 2: Уменьшение отступов внутри компонента
    padding: '6px 16px', // вместо стандартных 12px 16px
    
    // Способ 3: Уменьшение высоты строки
    lineHeight: 1.2,

    "&.Mui-selected": {
        backgroundColor: '#bdcccb',
        color: 'black',
    },
}));

export const DealTab = styled(Tab)(({ theme }) => ({
    alignItems: "center",
    textTransform: "none",
    color: 'gray',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
    transition: "all 0.2s ease-in-out",
    
    fontWeight: 'normal',
    fontSize: "18px",
    
    // Способ 1: Уменьшение высоты через minHeight
    minHeight: '20px', // вместо стандартных 48px
    
    // Способ 2: Уменьшение отступов внутри компонента
    padding: '6px 16px', // вместо стандартных 12px 16px
    height: '30px',
    
    // Способ 3: Уменьшение высоты строки
    lineHeight: 1.2,

    "&.Mui-selected": {
        backgroundColor: 'white',
        color: 'gray',
    },
}));

export const BCTab = styled(Tab)(({ theme }) => ({
    alignItems: "center",
    textTransform: "none",
    color: 'white',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
    transition: "all 0.2s ease-in-out",
    
    fontWeight: 'normal',
    fontSize: "18px",
    
    // Способ 1: Уменьшение высоты через minHeight
    minHeight: '20px', // вместо стандартных 48px
    
    // Способ 2: Уменьшение отступов внутри компонента
    padding: '8px 16px 6px 16px', // вместо стандартных 12px 16px
    height: '30px',
    
    // Способ 3: Уменьшение высоты строки
    lineHeight: 1.2,

    "&.Mui-selected": {
        backgroundColor: 'white',
        color: 'gray',
    },
}));


export const DNDTab = styled(Tab)(({ theme }) => ({
    alignItems: "center",
    textTransform: "none",
    color: "#828282",
    transition: "all 0.2s ease-in-out",
    fontSize: "15px",
    
    // Способ 1: Уменьшение высоты через minHeight
    minHeight: '30px', // вместо стандартных 48px
    height: "30px",
    
    // Способ 2: Уменьшение отступов внутри компонента
    padding: '12px 12px', // вместо стандартных 12px 16px
    
    // Способ 3: Уменьшение высоты строки
    lineHeight: 1.2,

    "&.Mui-selected": {
        color: "#078376",
        fontWeight: 'bold',
    },
}));

export const MPTab = styled(Tab)(({ theme }) => ({
    alignItems: "center",
    textTransform: "none",
    color: 'gray',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
    transition: "all 0.2s ease-in-out",
    
    fontWeight: 'normal',
    fontSize: "18px",
    
    // Способ 1: Уменьшение высоты через minHeight
    minHeight: '20px', // вместо стандартных 48px
    
    // Способ 2: Уменьшение отступов внутри компонента
    padding: '6px 16px', // вместо стандартных 12px 16px
    height: '30px',
    
    // Способ 3: Уменьшение высоты строки
    lineHeight: 1.2,

    "&.Mui-selected": {
        color: buttonColor,
        fontWeight: 'bold',
    },
}));

// окно для формирования штрих кодов и печати
// @ts-ignore
function BaCodeModal({ value, onClose}) {
    const [barcodeCount, setBarcodeCount] = useState(0)
    const [copyCount, setCopyCount] = useState(value.bcCopy || 1)
    const [checkCount, setCheckCount] = useState(0)
    const [loadingSettings, setLoadingSettings] = useState(true)
    /** @type {[any, Function]} */
    const [FBSQR, setFBSQR] = useState(undefined)
    const [useFBSPrint, setUseFBSPrint] = useState(false);
    
    
    
    console.log("VALBAR", value)

    const printRefv1 = useRef(null);
    const printRefv2 = useRef(null);
    const printRefv3 = useRef(null);

    const printContainerRef = useRef(null);

    const [printTrigger, setPrintTrigger] = useState(null);
    const [loadingPrint, setLoadingPrint] = useState(false);

    const preventDoubleClick = usePreventDoubleClick();

    const [tab, setTab] = useState(0);
    // @ts-ignore
    const handleChange = (event, newTab) => {
        setTab(newTab);
    };
    const tabTitle = ["Вариант 1", "Вариант 2"]

    const [delOpen, setDelOpen] = useState(false);
    const [image, setImage] = useState(undefined)
    const [customBCLoad, setCustomBCLoad] = useState(true)
    const [isPortrait, setIsPortrait] = useState(false)
    const [imageLoaded, setImageLoaded] = useState(false)

    const [useSize, setUseSize] = useState(true);
    const [useVendorCode, setUseVendorCode] = useState(true);
    const [useColor, setUseColor] = useState(true);
    const [useUser, setUseUser] = useState(true);
    const [useMaterials, setUseMaterials] = useState(true);
    const [useExpirationTime, setUseExpirationTime] = useState(false);
    const [useExpirationDate, setUseExpirationDate] = useState(false);

    useEffect(() => {

        const fetchData = async () => {
            setLoadingSettings(true)
            let ps = await get("product_settings/get", {bar:value.barcode, cid: value.cli, market: value.market, tz: value.tz})
            if (ps?.data?.printSettings) {
                console.log("TESSST", ps.data.printSettings)
                setUseSize(ps.data.printSettings.useSize);
                setUseVendorCode(ps.data.printSettings.useVendorCode);
                setUseColor(ps.data.printSettings.useColor);
                setUseUser(ps.data.printSettings.useUser);
                setUseMaterials(ps.data.printSettings.useMaterials);
                setUseExpirationTime(ps.data.printSettings.useExpirationTime);
                setUseExpirationDate(ps.data.printSettings.useExpirationDate);
            }
            setLoadingSettings(false)
        };

        if (value) {
            fetchData();
        }
    }, [value]);

    const startPrint = useReactToPrint({
        contentRef: printContainerRef,

        pageStyle: `
            @page {
                size: ${tab === 1
                    ? (isPortrait ? "40mm 58mm" : "58mm 40mm")
                    : "58mm 40mm"};
                margin: 0 !important;
                padding: 0 !important;
                marks: none;
            }

            body {
                margin: 0 !important;
                padding: 0 !important;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                background: white;
            }

            html, body {
                height: auto !important;
                overflow: visible !important;
            }

            * {
                box-sizing: border-box;
            }

            .barcode-print-page {
                width: ${tab === 1
                    ? (isPortrait ? "40mm" : "58mm")
                    : "58mm"};

                height: ${tab === 1
                    ? (isPortrait ? "58mm" : "40mm")
                    : "40mm"};

                page-break-after: always;
                break-after: page;
                overflow: hidden;
            }

            .barcode-print-page:last-child {
                page-break-after: auto;
                break-after: auto;
            }
        `,

        documentTitle: 'Компонент',

        onAfterPrint: () => {
            setLoadingPrint(false);
            setPrintTrigger(null);
            setDelOpen(true);
        }
    });

    const handlePrint = async () => {
        const totalCopies = Number(barcodeCount) * Number(copyCount);

        if (!totalCopies || totalCopies <= 0) {
            return;
        }

        setLoadingPrint(true);

        // Сохраняем фактическое количество экземпляров,
        // которое будет отправлено на печать.
        setCheckCount(totalCopies);

        if (tab === 0) {
            await post("product_settings/update", {
                barcode: value.barcode, 
                client_id: value.cli, 
                market: value.market, 
                tz: value.tz, 
                data: {
                    printSettings: {
                        useSize,
                        useVendorCode,
                        useColor,
                        useUser,
                        useMaterials,
                        useExpirationTime,
                        useExpirationDate
                    }
                }
                }
            )
        }

        // Даём React время отрендерить контейнер с копиями.
        setPrintTrigger({
            tab,
            count: totalCopies
        });
    };

    useEffect(() => {
        if (!printTrigger) {
            return;
        }

        const runPrint = async () => {
            // Небольшая задержка нужна, чтобы React успел
            // отрендерить все копии в printContainerRef.
            await new Promise(resolve => setTimeout(resolve, 100));

            startPrint();
        };

        runPrint();
    }, [printTrigger, startPrint]);

    // if (delOpen)
    // return (
    //     <div
    //     // style={{height:'350px', width:'600px'}}
    //     style={{height:'100%', width:'100%'}}
    //     >
    //         <div style = {{position: 'relative', paddingTop: '15px'}}>
    //             <div style = {{alignContent: 'center', alignItems: 'center'}}>
    //                 <div style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
    //                     <Typography variant="body1" sx={{fontWeight: '800', fontSize: '30px', display: 'row', marginTop:'20px'}}>Файлы распечатанный успешно?</Typography>
    //                 </div>
    //             </div>
    //             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop:'30px'}}>
    //             <Button variant="contained" onClick={} sx={{textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor:'#078376'}} >Да</Button>
    //             <Button variant="contained" onClick={() => setDelOpen(false)} sx={{textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor:'#078376'}}>Нет</Button>
    //             </div>
    //         </div>
    //     </div>
    // )
    const hideFiles = () => {
        //console.log('VALUE LOG', value)
        
        post("Logs/create", {
            deal_id:value.deal_id,
            user_type:"ful",
            user_id:value.user_id,
            type: "print_barcode",
            data: {
                count:checkCount,
                nmID: value.nmID,
                barcode: value.barcode,
                title: value.title,
                type: tabTitle[tab],
                vendorCode: value.vendorCode
            }
        })
    

        setDelOpen(false)
    }

    // Эффект для определения ориентации изображения после загрузки
    useEffect(() => {
        if (image) {
            const img = new Image();
            img.onload = () => {
                setIsPortrait(img.height > img.width);
                setImageLoaded(true);
                setTab(1)
            };
            img.src = image;
        }
    }, [image]);

    useEffect(() => {
        if (value?.print) {
            const checkPhoto = async () => {
                try {
                    if (value.print && value.print !== 'classic') {
                        setCustomBCLoad(true);
                        setImageLoaded(false); // Сбрасываем флаг загрузки
                        let tmp = await getFile("png", { path: value.print });
                        if (typeof tmp === "string") {
                            setImage(tmp);
                        }
                    }
                }
                catch (err) {
                    console.error("Error loading image:", err);
                }
                finally {
                    setCustomBCLoad(false);
                }
            }

            checkPhoto();
        }
    }, [value]);

    
    const BarcodeConstructor = ({scale}) => {
        return (
        <div style={{ display: 'flex', flexDirection: 'column', transform: `scale(${scale})`, transformOrigin: '0 0', width: `${100 / scale}%`, height: `${100 / scale}%`}}>
            <Card ref={printRefv1} sx={{ borderRadius: 3, width: "58mm", height: "40mm"}}>
                <CardContent sx={{padding: "2mm", marginTop:"1.2mm"}}>   
                    <div style={{display:"flex", flexDirection:"column", justifyContent:"center"}}>
                        <div style={{display:"flex", flexDirection:"row", width: "48mm", height: "7mm", marginLeft:"8mm", marginRight:"5mm"}}>
                            <div style={{width: "7mm", height: "6.4mm", display:"flex", flexDirection:"column", justifyContent:"center"}}>
                                <img src={EAC} style={{width: "6.4mm", height: "6.4mm"}}></img>
                            </div>
                            <div style={{width: "39mm", height: "7mm"}}>
                                <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", width: "35mm", height: "6.4mm"}}>
                                    <Typography align={'center'} sx={{ fontSize: "1.9mm", lineHeight:"2mm"}}>{value.brand}</Typography>
                                    {/* <Typography align={'center'} sx={{ width: "30mm", fontSize: "1.9mm", lineHeight:"2mm", whiteSpace: 'normal',wordWrap: 'break-word'}}>{value.title}</Typography> */}
                                    <Typography align={'center'} sx={{
                                        width: "30mm",
                                        fontSize: "1.9mm",
                                        lineHeight: "2mm",
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical',
                                    }}>
                                        {value.title}
                                    </Typography>

                                </div>
                            </div>
                        </div>
                        <div style={{zIndex: 6, display:"flex", flexDirection:"column", width: "48mm", height: "14mm", marginLeft:"8mm", marginRight:"5mm"}}>
                            {useVendorCode &&
                                <div style={{display:"flex", flexDirection:"row"}}>
                                    <div style={{display:"flex", flexDirection:"column", justifyContent:"center", width: "6mm", height: "2.5mm"}}>
                                        <Typography sx={{fontSize: "2mm"}}>Артикул</Typography>    
                                    </div>
                                    <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", width: "35mm", height: "3mm"}}>
                                        {value.vendorCode? 
                                            <Typography align={'center'} sx={{
                                                width: "30mm",
                                                fontSize: "1.5mm",
                                                lineHeight: "1.5mm",
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                            }}>
                                                {value.vendorCode}
                                            </Typography>
                                        : <p></p>}
                                    </div>
                                </div>
                            }
                            {useColor && 
                                <div style={{display:"flex", flexDirection:"row"}}>
                                    <div style={{display:"flex", flexDirection:"column", justifyContent:"center", width: "6mm", height: "2.5mm"}}>
                                        <Typography sx={{fontSize: "2mm"}}>Цвет</Typography>
                                    </div>
                                    <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", width: "35mm", height: "2.5mm"}}>
                                        {value.color? 
                                            <Typography align={'center'} sx={{
                                                width: "30mm",
                                                fontSize: "2.5mm",
                                                lineHeight: "2.5mm",
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 1,
                                                WebkitBoxOrient: 'vertical',
                                            }}>
                                                {value.color.join(", ")}
                                            </Typography>
                                        : <p></p>}
                                    </div>
                                </div>
                            }
                            {useSize && value.sizeTitle !== '0' &&
                                <div style={{display:"flex", flexDirection:"row"}}>
                                    <div style={{display:"flex", flexDirection:"column", justifyContent:"center", width: "6mm", height: "2.5mm"}}>
                                        <Typography sx={{fontSize: "2mm"}}>Размер</Typography>   
                                    </div>
                                    <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", width: "35mm", height: "2.5mm"}}>
                                        {value.sizeTitle? <Typography sx={{fontWeight: 'bold', fontSize: "2.5mm"}} align={'center'}>{value.sizeTitle || " "}</Typography>: <p></p>}
                                    </div>
                                </div>
                            }
                            {useUser && 
                                <div style={{display:"flex", flexDirection:"row", marginTop:"-0.3mm"}}>
                                    {value.vendor? <div style={{display:"flex", flexDirection:"column", justifyContent:"center", width: "6mm", height: "2.5mm"}}>
                                        <Typography sx={{fontSize: "2mm"}}>Поставщик</Typography>
                                    </div> : <></>}
                                    <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", width: "35mm", height: "2.5mm"}}>
                                        <Typography align={'center'} sx={{
                                            width: "30mm",
                                            fontSize: "2.5mm",
                                            lineHeight: "2.5mm",
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            display: '-webkit-box',
                                            WebkitLineClamp: 1,
                                            WebkitBoxOrient: 'vertical',
                                        }}>
                                            {value?.vendor?.trim().split(/\s+/).filter(Boolean).map((word, i, arr) => i === 0 ? word : arr.length === 2 && i === 1 ? word[0] + '.' : arr.length === 3 && i > 0 ? word[0] + '.' : word).join(' ')}
                                        </Typography>
                                    </div>
                                </div>
                            }
                            {useMaterials && 
                                <div style={{display:"flex", flexDirection:"row", marginTop:"0.8mm"}}>
                                    <div style={{display:"flex", flexDirection:"column", justifyContent:"center", width: "8mm", height: "4mm"}}>
                                        <Typography sx={{fontSize: "2mm"}}>Состав</Typography>
                                    </div>
                                    <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", width: "33mm", height: "4mm"}}>
                                        {value.material? 
                                            <Typography align={'center'} sx={{
                                                width: "30mm",
                                                fontSize: "1.8mm",
                                                lineHeight: "1.8mm",
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                            }}>
                                                {value.material?.join(", ")}
                                            </Typography>
                                        : <p></p>}
                                    </div>
                                </div>
                            }
                            { useExpirationTime && 
                                <div style={{display:"flex", flexDirection:"row"}}>
                                    <div style={{display:"flex", flexDirection:"column", justifyContent:"center", width: "8mm", height: "2.5mm"}}>
                                        <Typography sx={{fontSize: "2mm", textWrap: "nowrap"}}>Срок годности </Typography>
                                    </div>
                                    <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", width: "33mm", height: "2.5mm"}}>
                                        {value.expiration_time? 
                                            <Typography align={'center'} sx={{
                                                width: "30mm",
                                                fontSize: "2.5mm",
                                                lineHeight: "2.5mm",
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 1,
                                                WebkitBoxOrient: 'vertical',
                                            }}>
                                                {value.expiration_time} мес.
                                            </Typography>
                                        : <p></p>}
                                    </div>
                                </div>
                            }
                            {useExpirationDate && 
                                <div style={{display:"flex", flexDirection:"row"}}>
                                    <div style={{display:"flex", flexDirection:"column", justifyContent:"center", width: "8mm", height: "2.5mm"}}>
                                        <Typography sx={{fontSize: "2mm", textWrap: "nowrap"}}>Годен до </Typography>
                                    </div>
                                    <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", width: "33mm", height: "2.5mm"}}>
                                        {value.expiration_date? 
                                            <Typography align={'center'} sx={{
                                                width: "30mm",
                                                fontSize: "2.5mm",
                                                lineHeight: "2.5mm",
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 1,
                                                WebkitBoxOrient: 'vertical',
                                            }}>
                                                {formatDate(value.expiration_date)}
                                            </Typography>
                                        : <p></p>}
                                    </div>
                                </div>
                            }
                        </div>
                        <div style={{zIndex: 1, marginLeft:"5mm", marginTop: "-1.3mm"}}>
                            <Barcode format='CODE128' value={value.barcode} width={1.1} height={24} fontSize={16} textMargin={0} />
                        </div>
                    </div>               
                </CardContent>
            </Card>
        </div>
        )
    };

    const BarcodeCustom = () => {
        return(
            <Card 
                ref={printRefv3} 
                sx={{ 
                    borderRadius: 3, 
                    width: isPortrait ? "40mm" : "58mm",
                    height: isPortrait ? "58mm" : "40mm"
                }}
            >
                <CardContent sx={{ 
                    padding: "2mm", 
                    marginTop: "1.2mm",
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}>   
                    <img 
                        src={image} 
                        style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            display: "block"
                        }}
                        alt="Штрих-код"
                    />
                </CardContent>
            </Card>
        )
    };

    if (delOpen)
    return (
        <div style={{ height: '100%', width: '100%', borderRadius: "10px", backgroundColor: "white" }}>
            <div style={{ position: 'relative', paddingTop: '15px' }}>
                <div style={{ alignContent: 'center', alignItems: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Typography variant="body1" sx={{ fontWeight: '800', fontSize: '30px', marginTop: '20px' }}>
                            Файлы распечатаны успешно?
                        </Typography>
                    </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px' }}>
                    <Button 
                        variant="contained" 
                        onClick={hideFiles} 
                        sx={{ textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor: '#078376' }}
                    >
                        Да
                    </Button>

                    <Button 
                        variant="contained" 
                        onClick={() => setDelOpen(false)} 
                        sx={{ textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor: '#078376' }}
                    >
                        Нет
                    </Button>
                </div>
            </div>
        </div>
    );

    const scale = 1.5

    return (
        <div style={{width: '100%', height: '100%', overflow: 'hidden'}}>
            <Tabs value={tab} onChange={handleChange} aria-label="basic tabs example" sx={{
                "& .MuiTabs-indicator": {
                    display: "none"
                },
                height: "30px",
                minHeight: "30px"
            }}>

                <BCTab label={"КОНСТРУКТОР"} />
                {value?.print && value.print !== 'classic' && <BCTab label={"КЛИЕНТСКИЙ"} />}
            </Tabs>
            <div style={{width: '100%', height: 'calc(100% - 30px)', padding: "3% 3% 2% 3%", backgroundColor: 'white',display: 'flex', flexDirection: 'column', justifyContent: 'space-between', borderRadius: '10px', borderTopLeftRadius: tab === 0? '0px': "10px"}}>
                <TabPanel value={0} select={tab}>
                    {loadingSettings ? <Loading/>:
                    <div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                        <div style={{width: "58%"}}>
                            <BarcodeConstructor scale={scale}/>
                        </div>
                        <div style={{ width: "42%", display: 'flex', flexDirection: 'column', justifyContent: 'space-between',}}>
                            <div style={{
                                display: 'flex', flexDirection: 'column',
                            }}>
                                <NumInputDesign
                                    title={"Количество товаров"}
                                    val={barcodeCount}
                                    onChange={(v) => {setBarcodeCount(v); setCheckCount(v*copyCount)}}
                                    align='left'
                                />
                                <NumInputDesign
                                    title={"Копий на ед товара"}
                                    val={copyCount}
                                    onChange={(v) => {setCopyCount(v); setCheckCount(v*barcodeCount)}}
                                    align='left'
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={useVendorCode}
                                            onChange={(e) => setUseVendorCode(e.target.checked)}
                                            size="small"
                                            sx={{
                                                '& .MuiSwitch-switchBase.Mui-checked': {
                                                    color: '#078376',
                                                },
                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                    backgroundColor: '#078376',
                                                },
                                            }}
                                        />
                                    }
                                    label={<Typography sx={{ fontSize: '12px' }}>Артикул</Typography>}
                                    sx={{ margin: '4px 5px 0px 0px' }}
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={useColor}
                                            onChange={(e) => setUseColor(e.target.checked)}
                                            size="small"
                                            sx={{
                                                '& .MuiSwitch-switchBase.Mui-checked': {
                                                    color: '#078376',
                                                },
                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                    backgroundColor: '#078376',
                                                },
                                            }}
                                        />
                                    }
                                    label={<Typography sx={{ fontSize: '12px' }}>Цвет</Typography>}
                                    sx={{ margin: '4px 5px 0px 0px' }}
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={useSize}
                                            onChange={(e) => setUseSize(e.target.checked)}
                                            size="small"
                                            sx={{
                                                '& .MuiSwitch-switchBase.Mui-checked': {
                                                    color: '#078376',
                                                },
                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                    backgroundColor: '#078376',
                                                },
                                            }}
                                        />
                                    }
                                    label={<Typography sx={{ fontSize: '12px' }}>Размер</Typography>}
                                    sx={{ margin: '4px 5px 0px 0px' }}
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={useUser}
                                            onChange={(e) => setUseUser(e.target.checked)}
                                            size="small"
                                            sx={{
                                                '& .MuiSwitch-switchBase.Mui-checked': {
                                                    color: '#078376',
                                                },
                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                    backgroundColor: '#078376',
                                                },
                                            }}
                                        />
                                    }
                                    label={<Typography sx={{ fontSize: '12px' }}>Поставщик</Typography>}
                                    sx={{ margin: '4px 5px 0px 0px' }}
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={useMaterials}
                                            onChange={(e) => setUseMaterials(e.target.checked)}
                                            size="small"
                                            sx={{
                                                '& .MuiSwitch-switchBase.Mui-checked': {
                                                    color: '#078376',
                                                },
                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                    backgroundColor: '#078376',
                                                },
                                            }}
                                        />
                                    }
                                    label={<Typography sx={{ fontSize: '12px' }}>Состав</Typography>}
                                    sx={{ margin: '4px 5px 0px 0px' }}
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={useExpirationTime}
                                            onChange={(e) => setUseExpirationTime(e.target.checked)}
                                            size="small"
                                            sx={{
                                                '& .MuiSwitch-switchBase.Mui-checked': {
                                                    color: '#078376',
                                                },
                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                    backgroundColor: '#078376',
                                                },
                                            }}
                                        />
                                    }
                                    label={<Typography sx={{ fontSize: '12px' }}>Срок годности</Typography>}
                                    sx={{ margin: '4px 5px 0px 0px' }}
                                />
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={useExpirationDate}
                                            onChange={(e) => setUseExpirationDate(e.target.checked)}
                                            size="small"
                                            sx={{
                                                '& .MuiSwitch-switchBase.Mui-checked': {
                                                    color: '#078376',
                                                },
                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                    backgroundColor: '#078376',
                                                },
                                            }}
                                        />
                                    }
                                    label={<Typography sx={{ fontSize: '12px' }}>Годен до</Typography>}
                                    sx={{ margin: '4px 5px 0px 0px' }}
                                />
                                { FBSQR && 
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={useFBSPrint}
                                                onChange={(e) => setUseFBSPrint(e.target.checked)}
                                                size="small"
                                                sx={{
                                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                                        color: '#078376',
                                                    },
                                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                        backgroundColor: '#078376',
                                                    },
                                                }}
                                            />
                                        }
                                        label={<Typography sx={{ fontSize: '12px' }}>QR FBS</Typography>}
                                        sx={{ margin: '4px 5px 0px 0px' }}
                                    />
                                }
                                {!value.vendor ? <Typography variant='subtitle2' color='error'>{`Клиент не указал свои данные`}</Typography> : <></>}
                            </div>
                        </div>
                    </div>
                    }

                </TabPanel>
                {image && imageLoaded &&
                    <TabPanel value={1} select={tab}>
                        <div style={{ 
                            display: 'flex', 
                            flexDirection: 'column', 
                            alignItems: "center"
                        }}>
                            {customBCLoad ? <Loading></Loading> :
                                <div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                    <div style={{width: "58%", display: 'flex', justifyContent: 'center'}}>
                                        <BarcodeCustom/>
                                    </div>
                                    <div style={{ width: "42%", display: 'flex', flexDirection: 'column', justifyContent: 'space-between',}}>
                                        <div style={{
                                            display: 'flex', flexDirection: 'column',
                                        }}>
                                            <NumInputDesign
                                                title={"Количество товаров"}
                                                val={barcodeCount}
                                                onChange={(v) => {setBarcodeCount(v); setCheckCount(v*copyCount)}}
                                                align='left'
                                            />
                                            <NumInputDesign
                                                title={"Копий на ед товара"}
                                                val={copyCount}
                                                onChange={(v) => {setCopyCount(v); setCheckCount(v*barcodeCount)}}
                                                align='left'
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </TabPanel>
                }
                <Box
                    sx={{
                        display: "flex",
                        gap: 2,
                        width: "100%",
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}
                >
                    <CancelButton action={onClose} text={"ЗАКРЫТЬ"}/>
                    <OKButton action={preventDoubleClick(handlePrint, 1000)} text={"РАСПЕЧАТАТЬ"} disabled={barcodeCount*copyCount <= 0}/>
                    
                </Box>
                <div
                    style={{
                        position: 'fixed',
                        left: '-10000px',
                        top: 0,
                        width: '100%',
                        visibility: 'visible',
                        pointerEvents: 'none'
                    }}
                >
                    <div ref={printContainerRef}>
                        {printTrigger &&
                            <div>
                                {Array.from({ length: printTrigger.count }).map((_, index) => (
                                    <div
                                        key={index}
                                        className="barcode-print-page"
                                    >
                                        {tab === 0? <BarcodeConstructor scale={1}/>: <BarcodeCustom/>}
                                    </div>
                                ))}
                                {useFBSPrint && 
                                    <div
                                        key={printTrigger.count}
                                        className="barcode-print-page"
                                    >
                                        <RTImage value={FBSQR}/>
                                    </div>
                                }
                            </div>
                            
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

// модальное окно для отображения штрих кода
function BarCodeFormat({ value, desc }) {

    const [open, setOpen] = useState(false)


    if (value && value.barcode) {

        const barcodeString = value.barcode || "";
        const isCustom = barcodeString.includes('custom');

        const nmIDString = value.nmID || "";
        // @ts-ignore
        const isCustomProduct = nmIDString.includes('custom');

        const EditBarcode = () => {
            // const printWindow = window.open('', '_blank');

            // printWindow.document.write('<html><head></head><body onload="window.print()"><div style="display: flex; width: 100px;"><img style="max-width: 100%;" src="' + value + '"></div></body></html>');
            // printWindow.document.close();
            // ShowModal('Штрих код', <div style={{width: "550px", height: "300px"}}><BaCodeModal value={value} desc={desc}></BaCodeModal></div>, undefined);
            setOpen(true)
        }

        //console.log('BARCODE VAL', value)

        return (
            <div style={{ 
                width: "100%",
                display: 'flex', 
                alignItems: 'flex-start',
                justifyContent: 'space-between',
            }}>
                <div style={{ display: 'flex' }}>
                    <BarCode value={value}></BarCode>
                </div>
            
                <IconButton 
                    aria-label="edit" 
                    onClick={EditBarcode}
                >
                    <EditNoteIcon />
                </IconButton>
                <Dialog
                    open={open}
                    maxWidth={false}
                    PaperProps={{ sx: { borderRadius: "20px", p: "10px", backgroundColor: 'transparent', boxShadow: 'none', } }}
                    onClose={() => { setOpen(false) }}
                >
                    <div style={{ height: '400px', width: '650px'}}>
                        <BaCodeModal value={value} onClose={() => setOpen(false)}></BaCodeModal>
                    </div>
    
                </Dialog>
            </div>
        );
    } else {return <></>}
}

// компонент для получения qr кодов
// отстуствует часть для связи с бэком
// @ts-ignore
function QrCodeModal({ value, desc, onChange, canPrint = true, onClose, deal = undefined }) {
    //console.log("value", value)
    // состояние для хранения таблицы файлов, выбранных файлов, выбранных страниц, открытого файла и общего количества страниц
    // а также состояния загрузки
    const [fileBlob, setFileBlob] = useState([]);
    
    const [printedFiles, setPrintedFiles] = useState([]);
    const [printList, setPrintList] = useState([]);
    const [printCount, setPrintCount] = useState(0);
    const [printMet, setPrintMet] = useState(undefined);
    const [printTrigger, setPrintTrigger] = useState(null);
    const [copyCount, setCopyCount] = useState(value.copyCount || 0);
    

    const [selected, setSelected] = useState([]);

    const [tabIdx, setTabIdx] = useState("actual");
    // @ts-ignore
    const handleChangeTab = (event, newValue) => {if (newValue === 'actual') {setSelected([])};setTabIdx(newValue)};

    const [checked, setChecked] = useState(false);
    const [filter, setFilter] = useState("");

    const [error, setError] = useState(false);
    const [errorSel, setErrorSel] = useState(false);

    const [loading, setLoading] = useState(true);
    const [loadingPrint, setLoadingPrint] = useState(false);
    const [delOpen, setDelOpen] = useState(false);
    const [delLoading, setDelLoading] = useState(false);
    
    const $ds = useMemo(() => getDataSource('viewPdf'), []);
    // const $ds = useMemo(() => getDataSource('viewIMG'), []);
    const { socket } = useContext(SocketContext);

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            let result = [];
            let resultPrint = [];
            if (!value) {
                setLoading(false);
                return;
            }
            let tempPrinted = await get("UsedQRs/get", {
                nmId: value.nmID, 
                size: value.size, 
                client_id: value.client_id, 
                market: value.market
            });
            const printedHistory = tempPrinted?.message || [];

            const printedMap = {}
            printedHistory.map(pel => {printedMap[`${pel.path}_${pel.page}`] = pel})
            // const printedSet = new Set(
            //     printedHistory.map(pel => `${pel.path}_${pel.page}`)
            // );

            const currentPaths = (value.qr || []).map(el => el.path);
            // @ts-ignore
            const historyPaths = [...new Set(printedHistory.map(pel => pel.path))];
            const allSources = [...(value.qr || [])];
            historyPaths.forEach(hPath => {
                if (!currentPaths.includes(hPath)) {
                    allSources.push({ path: hPath });
                }
            });
            await Promise.all(allSources.map(async (el, mind) => {
                const res = await getFile('pdf', { path: el.path });
                if (!res || (typeof res === 'object' && 'status' in res)) {
                    console.error(`Ошибка загрузки файла: ${el.path}`, res);
                }
                else {
                    try {
                        const pdf = await getDocument(res).promise;
                        
                        for (let i = 1; i <= pdf.numPages; i++) {
                            const pageIdx = i - 1;
                            const pageKey = `${el.path}_${pageIdx}`;
                            // const isPrinted = printedSet.has(pageKey);
                            const isOriginalFile = currentPaths.includes(el.path);

                            // if (isPrinted) {
                            if (printedMap[pageKey]) {
                                const page = await pdf.getPage(i);
                                const pinfo = await page.getTextContent();
                                const textStrings = pinfo.items.filter(item => 'str' in item).map(item => item.str);
                                // const viewport = page.getViewport({ scale: 3.0 });
                                // const canvas = document.createElement("canvas");
                                // canvas.width = viewport.width;
                                // canvas.height = viewport.height;
                                

                                const item = { 
                                    id: pageKey, 
                                    page: pageIdx, 
                                    data: page, 
                                    path: el.path, 
                                    info: pinfo.items, 
                                    fs: textStrings.join(' ').toLowerCase(), 
                                    // render: canvas.toDataURL(),
                                    index: parseInt(`${mind}${i}`),
                                    deal_id: printedMap[pageKey].deal?.id || undefined
                                };
                                resultPrint.push(item);
                            } else if (isOriginalFile) {
                                const page = await pdf.getPage(i);
                                const pinfo = await page.getTextContent();
                                const textStrings = pinfo.items.filter(item => 'str' in item).map(item => item.str);
                                // const viewport = page.getViewport({ scale: 3.0 });
                                // const canvas = document.createElement("canvas");
                                // canvas.width = viewport.width;
                                // canvas.height = viewport.height;

                                const item = { 
                                    id: pageKey, 
                                    page: pageIdx, 
                                    data: page, 
                                    path: el.path, 
                                    info: pinfo.items, 
                                    fs: textStrings.join(' ').toLowerCase(), 
                                    // render: canvas.toDataURL(),
                                    index: parseInt(`${mind}${i}`)
                                };
                                result.push(item);
                            }
                        }
                    } catch (pdfError) {
                        console.error(`Ошибка обработки PDF: ${el.path}`, pdfError);
                    }
                }
            }))

            result.sort((a, b) => a.index - b.index);
            console.log("resultPrint", resultPrint)
            if (deal) {resultPrint = resultPrint.filter((fel) => fel.deal_id === deal)}
            resultPrint.sort((a, b) => a.index - b.index);
            setFileBlob(result);
            setPrintedFiles(resultPrint);
        } catch (error) {
            console.error("Global fetchData error:", error);
        } finally {
            setLoading(false);
        }
    }, [value, get, getFile]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleInputChange = (v) => {
        
        const newPrintList = fileBlob.slice(0, v)
        setPrintList(newPrintList)
        setPrintCount(v);
    };
    
    // @ts-ignore
    const handleBlur = () => {
        if (printCount < 0) {
            setPrintCount(1);
        } else if (printCount > fileBlob.length) {
            setPrintCount(fileBlob.length);
        }
    };


    const printContainerRef = useRef(null);
    const printSelContainerRef = useRef(null);


    const startPrint = useReactToPrint({
        contentRef:printMet === "count"? printContainerRef: printSelContainerRef,
        pageStyle: `
            @page { size: auto; margin: 0; }
            body { margin: 0; -webkit-print-color-adjust: exact; }
            html, body { height: auto !important; } 
            `,
        documentTitle: 'Компонент',
        onAfterPrint: () => {
            setLoadingPrint(false);
            setDelOpen(true);
        }
    });

    
    const handlePrint = (ptype) => {

        const localRender = async () => {

            let tmp = undefined
            switch (ptype) {
                case "count":
                    tmp = printList
                    break;
                case "selected":
                    tmp = selected
                    break;
            }

            await Promise.all(tmp.map(async (el) => {
                if (!el.render) {
                    let page = el.data
                    const viewport = page.getViewport({ scale: 3.0 });
                    const canvas = document.createElement("canvas");
                    canvas.width = viewport.width;
                    canvas.height = viewport.height;
                    const context = canvas.getContext("2d");
                    await page.render({ canvasContext: context, viewport }).promise;
                    el.render = canvas.toDataURL()

                }
            }))

            // Дублируем элементы согласно copyCount 
            const duplicatedTmp = tmp.flatMap(el => Array(copyCount).fill(el));

            // Обновляем состояние с дублированным массивом
            switch (ptype) {
                case "count":
                    setPrintList(duplicatedTmp);
                    break;
                case "selected":
                    setSelected(duplicatedTmp);
                    break;
            }

            

            setPrintTrigger({ type: ptype }); // Это запустит useEffect
        }

        switch (ptype) {
            case "count":
                if (printCount === undefined || (typeof (printCount) === 'string' && printCount === '') || printCount === 0) {
                    setError(true);
                    
                    return; // Не продолжаем, если ошибка
                } else {
                    setError(false);
                }
                break;
            case "selected":
                if (selected.length === 0) {
                    setErrorSel(true);
                    return; // Не продолжаем, если ошибка
                } else {
                    setErrorSel(false);
                }
                break;
        }
        // Устанавливаем printMet и триггер печати
        setPrintMet(ptype);
        setLoadingPrint(true)
        localRender()
    };

    useEffect(() => {
        if (printTrigger) {
            startPrint();
            setPrintTrigger(null); // Сбрасываем триггер после печати
        }
    }, [printTrigger, startPrint]); // Зависимости: триггер и startPrint

    const recover = async () => {
        //console.log("selected", selected)
        setFileBlob([...fileBlob, ...selected])
        let result = printedFiles.filter(A => !selected.some(B => A.id === B.id));
        setPrintedFiles(result)
        let temp = [...selected]
        //console.log("temp", temp)
        temp.map(async(el) => {
            post("UsedQRs/del", {nmID:value.nmID, size:value.size, path:el.path, page:el.page})
        })
        if (onChange) {onChange({data:{len:selected.length, act: "recover"}, row:{id:value.id}})}
        post("Logs/create", {
            deal_id:value.deal_id,
            user_type:"ful",
            user_id:value.user_id,
            type: "recover_qr",
            data: {
                count:selected.length,
                product: value.product
            }
        })
        setSelected([])
    }

    const delFiles = async () => {
        let result = printedFiles.filter(A => !selected.some(B => A.id === B.id));
        setPrintedFiles(result)
        let temp = [...selected]
        let res = {}
        await Promise.all(temp.map(async (el) => {
            if (res[el.path]) {res[el.path].push(el.page)}
            else {res[el.path] = [el.page]}
            await post("UsedQRs/del", {nmID:value.nmID, size:value.size, path:el.path, page:el.page})
        }))
        await Promise.all(Object.keys(res).map(async (el) => {
            await delFts('/delete-pages', {path:el, pages:res[el]}, socket)
        }))
        setSelected([])
    }

    const hideFiles = async () => {
        if (tabIdx === "printed") {
            setPrintList([]);
            setPrintCount(0);
            setSelected([]);
            setDelOpen(false);
            return;
        }
        setDelLoading(true)
        let itemsToProcess = [];
        if (printMet === "count") {
            itemsToProcess = [...new Set(printList)];
        } else if (printMet === "selected") {
            itemsToProcess = [...new Set(selected)];
        }

        try {
            await Promise.all(itemsToProcess.map(el => 
                post("UsedQRs/add", {
                    nmID: value.nmID, 
                    size: value.size, 
                    path: el.path, 
                    page: el.page, 
                    client_id: value.client_id, 
                    market: value.market,
                    deal_id: value.deal_id
                })
            ));
            const remaining = fileBlob.filter(A => !itemsToProcess.some(B => A.id === B.id));
            setFileBlob(remaining);
            setPrintedFiles(prev => [...prev, ...itemsToProcess]);

            if (onChange) {
                onChange({ data: { len: itemsToProcess.length, act: "print" }, row: { id: value.id } });
            }
            
            post("Logs/create", {
                deal_id:value.deal_id,
                user_type:"ful",
                user_id: value.user_id,
                type: "print_qr",
                data: {
                    count:itemsToProcess.length,
                    product: value.product
                }
            });

            setPrintList([]);
            setPrintCount(0);
            setSelected([]);
        } catch (err) {
            console.error("Ошибка при сохранении статуса печати:", err);
            alert("Не удалось сохранить данные о печати в базу!");
        }

        setDelLoading(false)
        setDelOpen(false);
    };


    const onSelectPages = useCallback((indata, type) => {
        let res = []
        switch (type) {
            case "fb": {
                indata.map((el) => {
                    let idx = fileBlob.findIndex((fel) => fel.id === el)
                    if (idx > -1 ) {res.push(fileBlob[idx])}
                }); break;
            }
            case "pf": {
                indata.map((el) => {
                    let idx = printedFiles.findIndex((fel) => fel.id === el)
                    if (idx > -1 ) {res.push(printedFiles[idx])}
                }); break;
            }
        }
        setSelected(res)
    }, [fileBlob, printedFiles, setSelected]);

    
    const exportPrinted = async () => {
        const kizList = [];
        console.log("printedFiles", printedFiles)
        for (const pageData of printedFiles) {
            try {
                console.log("Сканируем страницу:", pageData.page);

                const results = await scanPageForKiz(pageData.data);

                results.forEach((result) => {
                    console.log("Найден КИЗ:", result.text);

                    kizList.push({
                        code: formatGS1Code(result.text),
                        page: pageData.page,
                        path: pageData.path,
                    });
                });
            } catch (error) {
                console.error(
                    `Ошибка сканирования страницы ${pageData.page}`,
                    error
                );
            }
        }

        console.log("ВСЕ НАЙДЕННЫЕ КИЗЫ:", kizList);

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Мои данные');

        let filename = `Список использованных кизов`;
        const DataArray = [];
        
        worksheet.columns = [
            { header: 'Код', key: 'code'},
        ];

        for (let item of kizList) {
            DataArray.push({code: item.code})
        }
        
        worksheet.addRows(DataArray);

        // 4. Генерируем файл как буфер
        const buffer = await workbook.xlsx.writeBuffer();

        // 5. Создаем Blob и скачиваем файл
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        
        // saveAs(blob, 'МойФайл.xlsx');

        const blobUrl = URL.createObjectURL(blob);

        // alert('Браузер заблокировал открытие в новой вкладке. Файл будет скачан.');
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = `${filename}.xlsx`
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Всегда освобождаем память от Blob-URL
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
    }

    if (delOpen)
    return (
        <div
        // style={{height:'350px', width:'600px'}}
        style={{height:'100%', width:'100%', borderRadius: "10px", backgroundColor:'white'}}
        >
            {delLoading?
                <Loading/>
            :
                <div style = {{position: 'relative', paddingTop: '15px'}}>
                    <div style = {{alignContent: 'center', alignItems: 'center'}}>
                        <div style={{ display: 'flex', flexDirection:'column', alignItems: 'center' }}>
                            <Typography variant="body1" sx={{fontWeight: '800', fontSize: '30px', display: 'row', marginTop:'20px'}}>Файлы распечатаны успешно?</Typography>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop:'30px'}}>
                        <Button variant="contained" onClick={hideFiles} sx={{textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor:'#078376'}} >Да</Button>
                        <Button variant="contained" onClick={() => setDelOpen(false)} sx={{textTransform: 'none', margin: '10px', fontWeight: 'bold', backgroundColor:'#078376'}}>Нет</Button>
                    </div>
                </div>
            }
        </div>
    )
    return (
        <div style={{width: '100%', height: "100%"}}>
            <Tabs value={tabIdx} onChange={handleChangeTab} aria-label="basic tabs example" sx={{
                "& .MuiTabs-indicator": {
                    display: "none"
                },
                height: "30px",
                minHeight: "30px"
            }}>
                <BCTab label='АКТУАЛЬНЫЕ' value={'actual'} />
                <BCTab label='ИСПОЛЬЗОВАННЫЕ' value={'printed'} />
            </Tabs>
            <div style={{width: '100%', height: 'calc(100% - 30px)', display: 'flex', flexDirection: 'column', backgroundColor: 'white', padding: "2%", borderRadius: "10px", borderTopLeftRadius: tabIdx === 'actual'? "0px": "10px"}}>
                <div style={{display: 'flex', flexDirection: 'row', width: "100%", height: "90%", justifyContent: 'space-between'}}>
                    <div style={{width: "60%", height: "100%",}}>
                        <TabPanel select={tabIdx} value={'actual'}>
                            <Scrollbars
                                style={{ width: '100%', height: 'calc(100% - 34px)'}} 
                            >
                                <ReportTable 
                                    ds={{...$ds, descr: {...$ds.descr, showCheckboxes: false}}} 
                                    data={fileBlob}
                                    onSelect={(data) => onSelectPages(data, "fb")}
                                    autoPagination={20}
                                />
                            </Scrollbars>
                            <Typography sx={{fontSize: "12pt", height: "24px", marginTop: "10px"}}>
                                Всего: {fileBlob?.length || 0} 
                            </Typography>
                        </TabPanel>
                        <TabPanel select={tabIdx} value={'printed'}>
                            <Scrollbars
                                style={{ width: '100%', height: 'calc(100% - 34px)'}} 
                            >
                                <ReportTable 
                                    ds={$ds} 
                                    data={!checked? printedFiles: printedFiles.filter((el) => el.fs.includes(filter.toLowerCase()))}
                                    onSelect={(data) => onSelectPages(data, "pf")}
                                    autoPagination={10}
                                />
                            </Scrollbars>
                            <Typography sx={{fontSize: "12pt", height: "24px", marginTop: "10px"}}>
                                Всего: {printedFiles?.length || 0} 
                            </Typography>
                        </TabPanel>
                    </div>
                    <div style={{width: "39%"}}>
                        {canPrint && 
                            <div style={{
                                display: 'flex', flexDirection: 'column',
                            }}>

                                {tabIdx === "actual" ? <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div style={{display: 'flex', flexDirection: 'column', gap: "5px", width: "80%"}}>
                                        <NumInputDesign title={'Количество на печать'} val={printCount} onChange={(v) => handleInputChange(v)}/>                                    
                                        <NumInputDesign title={'Количество копий'} val={copyCount} onChange={(v) => setCopyCount(v)}/>
                                    </div>              
                                    <div style={{width: "20%"}}>
                                        {loadingPrint && <Loading/>}
                                    </div>
                                </div>: <></>}
                                {tabIdx === "printed" && <ClassicSearch customWidth={"100%"} setChecked={setChecked} setFilter={setFilter} checked={checked}/>}
                                {tabIdx === "printed"? <div style={{ marginTop: '10px', width: '100%' }}>
                                    <Button 
                                        onClick={() => recover()} 
                                        variant="contained" 
                                        disabled={selected.length === 0}
                                        sx={{ ":hover": { bgcolor: buttonColorHover}, width: '100%', color: "white", textTransform: 'none', backgroundColor: buttonColor, borderRadius: "10px", fontSize: "16px", height: "35px"}}
                                    >ВОССТАНОВИТЬ</Button>
                                </div>: <></>}
                                {tabIdx === "printed"? <div style={{ marginTop: '10px', width: '100%' }}>
                                    <Button 
                                        onClick={() => delFiles()}  
                                        variant="contained" 
                                        disabled={selected.length === 0}
                                        sx={{ ":hover": { bgcolor: buttonColorHover}, width: '100%', color: "white", textTransform: 'none', backgroundColor: buttonColor, borderRadius: "10px", fontSize: "16px", height: "35px"}}
                                    >УДАЛИТЬ</Button>
                                </div>: <></>}
                            </div>
                        }
                    </div>
                </div>
                <Box
                    sx={{
                        display: "flex",
                        gap: 2,
                        height: "10%",
                        width: "100%",
                        justifyContent: 'space-between',
                        alignItems: 'flex-end'
                    }}
                >
                
                    <CancelButton action={onClose} text={"ЗАКРЫТЬ"}/>
                    {canPrint && <OKButton action={() => handlePrint(tabIdx === 'actual'? 'count':'selected')} text={"ПЕЧАТЬ"} disabled={loadingPrint || (tabIdx === 'actual' && (printCount*copyCount === 0 || printCount > fileBlob.length)) || (tabIdx !== 'actual' && selected.length === 0 )}/>}
                    {!canPrint && tabIdx !== 'actual' && <OKButton action={() => exportPrinted()} text={"СКАЧАТЬ"} disabled={printedFiles.length == 0}/>}
                    
                </Box>
            </div>
            <div style={{ position: 'absolute', left: '-9999px', top: 0 }}>
                <div ref={printContainerRef} >
                    <div>
                        {printList.length>0 && printList.map((item, index) => (
                            <img key={`print-${index}`} src={item.render} style={{ width: '53mm', height: '37mm', margin:"0.5mm", pageBreakAfter: 'always'}} />
                        ))}
                    </div>
                </div>
            </div>
            <div style={{ position: 'absolute', right: '9999px', top: 0 }}>
                <div ref={printSelContainerRef} >
                    <div>
                        {selected.map((item, index) => (
                            <img key={`print-${index}`} src={item.render} style={{ width: '53mm', height: '37mm', margin:"0.5mm", pageBreakAfter: 'always' }} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

// отображение QR кода
function QrCodeFormat({ value, desc, onChange }) {
    console.log("QrCodeFormat", value)

    const [open, setOpen] = useState(false)

    if (value) {

        const print = () => {
            setOpen(true)
            // ShowModal(
            //     <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            //         <span>Печать QR-кодов</span>
                    
            //         <div style={{ 
            //             display: 'flex', 
            //             flexDirection: 'column', 
            //             marginLeft: '20px',
            //             lineHeight: 1.2 
            //         }}>
            //             <Typography variant="body2" sx={{ fontSize: '12pt' }}>
            //                 {value.product.title}
            //             </Typography>
            //             <Typography variant="body2" sx={{ fontSize: '12pt' }}>
            //                 Артикул: {value.product.vendorCode}, баркод: {value.product.barcode}
            //             </Typography>
            //         </div>
            //     </div>, 
            //     <div style={{ height: '700px', width: '1000px', padding: '12px' }}>
            //         <QrCodeModal value={value} desc={desc} onChange={onChange}/>
            //     </div>, 
            //     undefined
            // );
        }

        return (
            
        <div style={{display: 'flex', flexDirection: "column", alignItems: 'center'}}>
            <Dialog
                open={open}
                maxWidth={false}
                PaperProps={{ sx: { borderRadius: "20px", p: "10px", backgroundColor: 'transparent', boxShadow: 'none'} }}
                onClose={() => { setOpen(false) }}
            >
                <div style={{ height: '500px', width: '700px'}}>
                    <QrCodeModal value={value} desc={desc} onChange={onChange} onClose={() => {setOpen(false)}}/>
                </div>

            </Dialog>
            {value.qr.length === 0?
                <Box
                    component="button"
                    onClick={print}
                    sx={{
                        width: '70px',
                        height: 64,
                        border: '1px solid #BDBDBD',
                        borderRadius: '4px',
                        color: '#BDBDBD',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                        textTransform: 'none',
                        whiteSpace: 'normal',
                        fontSize: '0.8rem',
                        lineHeight: 1.2,
                        background: 'transparent',
                        cursor: 'pointer',
                        padding: 0,
                        '&:hover': hoverStyle
                    }}
                >
                    <>QR-кодов<br />нет</>
                </Box>:
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <IconButton size='large' onClick={print}>
                        <QrCode2Icon sx={{ fontSize: "3rem", '&:hover': hoverStyle}}></QrCode2Icon>
                    </IconButton>
                </div>
            }
            <Typography>{value.count}</Typography>
        </div>
        );
    } else {
        return (
            <NoData></NoData>
        );
    }
}


// отображение QR кода
function QrCodeFormatNoPrint({ value, desc, onChange }) {
    console.log("QrCodeFormatNoPrint", value)
    const [open, setOpen] = useState(false)
    if (value) {

        const print = () => {
            setOpen(true)
            // ShowModal(
            //     <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            //         <span>Печать QR-кодов</span>
                    
            //         <div style={{ 
            //             display: 'flex', 
            //             flexDirection: 'column', 
            //             marginLeft: '20px',
            //             lineHeight: 1.2 
            //         }}>
            //             <Typography variant="body2" sx={{ fontSize: '12pt' }}>
            //                 {value.product.title}
            //             </Typography>
            //             <Typography variant="body2" sx={{ fontSize: '12pt' }}>
            //                 Артикул: {value.product.vendorCode}, баркод: {value.product.barcode}
            //             </Typography>
            //         </div>
            //     </div>, 
            //     <div style={{ height: '700px', width: '1000px', padding: '12px' }}>
            //         <QrCodeModal value={value} desc={desc} onChange={onChange} canPrint={false}/>
            //     </div>, 
            //     undefined
            // );
        }

        return (
            
        <div style={{display: 'flex', flexDirection: "column", alignItems: 'center'}}>
            <Dialog
                open={open}
                maxWidth={false}
                PaperProps={{ sx: { borderRadius: "20px", p: "10px", backgroundColor: 'transparent', boxShadow: 'none'} }}
                onClose={() => { setOpen(false) }}
            >
                <div style={{ height: '500px', width: '700px'}}>
                    <QrCodeModal value={value} desc={desc} onChange={onChange} canPrint={false} deal={value.deal_id} onClose={() => {setOpen(false)}}/>
                </div>

            </Dialog>
            {value.qr.length === 0?
                <Box
                    component="button"
                    onClick={print}
                    sx={{
                        width: '70px',
                        height: 64,
                        border: '1px solid #BDBDBD',
                        borderRadius: '4px',
                        color: '#BDBDBD',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                        textTransform: 'none',
                        whiteSpace: 'normal',
                        fontSize: '0.8rem',
                        lineHeight: 1.2,
                        background: 'transparent',
                        cursor: 'pointer',
                        padding: 0,
                        '&:hover': hoverStyle
                    }}
                >
                    <>QR-кодов<br />нет</>
                </Box>:
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <IconButton size='large' onClick={print}>
                        <QrCode2Icon sx={{ fontSize: "3rem", '&:hover': hoverStyle}}></QrCode2Icon>
                    </IconButton>
                </div>
            }
            <Typography>{value.count}</Typography>
        </div>
        );
    } else {
        return (
            <NoData></NoData>
        );
    }
}

// export function InputTestValueformat(val, func, index ) {
//     // const [localvar, setLocalvar] = useState(val)
//     let localvar = val;
//     let flag = true;
//     const handleClick = () => {
//         flag = true;
//         func(localvar, index)
//     }
//     const handleChange = (e) => {
//         // setLocalvar(e.target.value);
//         localvar = e.target.value;
//         flag = false;
//     }
//     return (
//         <div>
//             <IMaskInput onChange={handleChange} style={{ width: '100px', height: '30px', padding: '5px', fontSize: '14px', textAlign: 'center', borderRadius: '7px' }} value={localvar} placeholder='value' mask={Number} radix="." definitions={{ '#': /[1-9]/, }} />
//             <Tooltip title="Save value" style={{ top: '10%' }}>
//                 <IconButton onClick={handleClick}>
//                     <SaveIcon color={flag ? 'success' : 'error'} />
//                 </IconButton>
//             </Tooltip>
//         </div>
//     )
// }

// Компонент для ввода и сохранения значения с форматированием
// @ts-ignore
export const InputTestValueformat = ( {val, func, index, column, type} ) => {
    // console.log('type', type)
  const [localVar, setLocalVar] = useState(type === 'enum'? val.val: val);
  const [isModified, setIsModified] = useState(false);

  useEffect(() => {
    setLocalVar(val); // Обновлять при внешнем изменении
    setIsModified(false);
  }, [val]);

  const handleClick = () => {
    func(localVar, index);
    setIsModified(false);
  };

  const handleChange = (e) => {
    setLocalVar(e.target.value);
    setIsModified(true);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <IMaskInput
        onChange={handleChange}
        style={{
          width: '100px',
          height: '30px',
          padding: '5px',
          fontSize: '14px',
          textAlign: 'center',
          borderRadius: '7px',
        }}
        value={localVar}
        placeholder="value"
        mask={Number}
        radix="."
        definitions={{ '#': /[1-9]/ }}
      />
      <Tooltip title="Save value">
        <IconButton onClick={handleClick}>
          <SaveIcon color={isModified ? 'error' : 'success'} />
        </IconButton>
      </Tooltip>
    </div>
  );
};

// дефалтный вывод текста
export function DefaultTypography({ value}) { //РЕДАЧИМ
    if (value !== undefined){
    return (
    <div style={{display: 'flex', 
                width: '100%'
                }}>
        <Typography variant="subtitle2">{value}</Typography>
    </div>
    )}
}

export function PrintedQrCount({ value }) {
    const [printCount, setPrintCount] = useState(undefined);
    const barcode = value.product.barcode
    console.log('WHOLE VALUE', value)

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await get('Logs/getPrintQr', { did: value.deal_id});
                
                if (Array.isArray(response)) {
                    const total = response.reduce((sum, item) => {
                        try {
                            const parsedData = JSON.parse(item.data);
                            console.log('PARSED DATA', parsedData)
                            const itemBarcode = parsedData.product?.barcode;

                            if (itemBarcode && String(itemBarcode) === String(barcode)) {
                                return sum + (parsedData.count || 0);
                            }
                            
                            return sum;
                        } catch (e) {
                            console.error(e);
                            return sum;
                        }
                    }, 0);

                    setPrintCount(total);
                }
            } catch (e) {
                console.error(e);
            }
        };

        if (value !== undefined) {
            fetchData();
        }
    }, [value]);

    if (value === undefined) return null;

    return (
        <div style={{ display: 'flex', width: '100%' }}>
            <Typography variant="subtitle2">{printCount}</Typography>
        </div>
    );
}

export function DefaultTypographyShort({ value}) { //РЕДАЧИМ
    if (value !== undefined) {
        const isLongText = String(value).length > 10;

        return (
            <div style={{
                display: 'flex',
                width: '100%'
            }}>
                <Tooltip 
                    title={value} 
                    placement="top" 
                    arrow 
                    disableHoverListener={!isLongText}
                    componentsProps={{
                        tooltip: {
                            sx: {
                                fontSize: '16px',
                                padding: '8px 12px',
                            },
                        },
                    }}
                >
                    <Typography 
                        variant="subtitle2"
                        sx={{
                            position: 'relative',
                            overflow: 'hidden',
                            // Если текст длинный — в одну строку, если нет — обычный перенос
                            whiteSpace: isLongText ? 'nowrap' : 'normal',
                            width: '100%',
                            '&::after': isLongText ? {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                bottom: 0,
                                width: '30px',
                                background: `linear-gradient(to right, rgba(255, 255, 255, 0), #ffffffff)`,
                                pointerEvents: 'none',
                            } : {},
                        }}
                    >
                        {value}
                    </Typography>
                </Tooltip>
            </div>
        )
    }
}

export function DefaultTypographyMid({ value}) { //РЕДАЧИМ
    if (value !== undefined) {
        const maxLen = 50
        const isLongText = String(value).length > maxLen;
        console.log("isLongText", isLongText)

        return (
            <div style={{
                display: 'flex',
                width: '100%'
            }}>
                <Tooltip 
                    title={value} 
                    placement="top" 
                    arrow 
                    disableHoverListener={!isLongText}
                    componentsProps={{
                        tooltip: {
                            sx: {
                                fontSize: '16px',
                                padding: '8px 12px',
                            },
                        },
                    }}
                >
                    <Typography 
                        variant="subtitle2"
                        sx={{
                            position: 'relative',
                            overflow: 'hidden',
                            // Если текст длинный — в одну строку, если нет — обычный перенос
                            whiteSpace: isLongText ? 'nowrap' : 'normal',
                            width: '100%',
                            '&::after': isLongText ? {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                bottom: 0,
                                width: '30px',
                                background: `linear-gradient(to right, rgba(255, 255, 255, 0), #ffffffff)`,
                                pointerEvents: 'none',
                            } : {},
                        }}
                    >
                        {isLongText? value.slice(0,maxLen): value}
                    </Typography>
                </Tooltip>
            </div>
        )
    }
}


export function ColorsList({value}) {
    return (
        <div>
            {value?.map((el) => (
                <DefaultTypography value={el}/>
            ))}
        </div>
    )
}


export function ValTypography({ val, type = undefined }) {
    if (type) {
        switch (type){
        case "enum":
            return <></>
        default :
            return <Typography>{val}</Typography>
    }    
    }
    else {return <Typography>{val}</Typography>}
}

// вывод статуса оплаты
// @ts-ignore
function StatusPay({ value, desc }) {
    switch (value) {
        case 'noPay':
            return (<Typography color='error'>{`Не оплачено`}</Typography>);
        case 'Pay':
            return (<Typography color='primary'>{`Оплачено`}</Typography>);
        default:
            return (<Typography>{value}</Typography>)
    }
}

export function StatusPayChanged({ value, onChange }) {
    //console.log("value", value)
    if (!value.value) {value.value = 'noPay'}
    return (
        <Select
            style={{width:"100%", minWidth: "150px", marginTop:'5px', borderRadius:"8px"}}
            defaultValue='noPay'
            value={value.value}
            onChange={(event) => { if(onChange) onChange({row:{id:value.id}, data:event.target.value})}}
        >
            <MenuItem value={'noPay'}>{'Не оплачено'}</MenuItem>
            <MenuItem value={'Pay'}>{'Оплачено'}</MenuItem>
        </Select>
    )
}

// вывод статуса поставки
// @ts-ignore
function StatusDeal({ value, desc }) {

    const statuses = {
        'pik_goods': {title: 'Прием', index:4},
        'moving_deals': {title: 'Обработка', index:3},
        'products_storage': {title: 'Хранение', index:2},
        'products_shipment': {title: 'Отгрузка', index:1},
        'archive': {title: 'Завершенная', index:0},
    }

    if (!value) return null;    

    return (
        <div style={{width: "100%", display: "flex", flexDirection: "row", justifyContent: 'center'}}>
            <Tooltip 
                // title={statuses[value.type].title}
                // title={value.title}
                title={
                    <div>
                        <strong>{statuses[value].title}</strong>
                        {/* <br />
                        {value.title} */}
                    </div>
                }
                slotProps={{
                    popper: {
                        modifiers: [
                            {
                            name: 'offset',
                            options: {
                                offset: [70, -45], // [горизонталь, вертикаль]. Положительное число отдаляет.
                            },
                            },
                        ],
                    },
                }}
            >
                <div style={{ display: 'inline-block' }}>
                    <HalfCircle size={60} tickLength={1} baseColor={"#b5d7d4"} highlightColor={"#208f84"} highlightedIndex={statuses[value].index}/>
                </div>
            </Tooltip>
        </div>
    );
}

    const HalfCircle = ({
        size = 100,
        baseColor = 'gray',
        highlightColor = 'orange',
        highlightedIndex = -1,        // индекс выделяемого сектора (0…4), -1 = ничего не выделять
        tickColor = 'white',
        tickAngleStep = 36,
        tickLength = 0.8,
        strokeWidth = 2,
        }) => {
        const radius = size / 2;
        const centerX = size / 2;
        const centerY = radius;

        // Массив углов (границы секторов)
        const angles = [];
        for (let deg = 0; deg <= 180; deg += tickAngleStep) {
            angles.push(deg);
        }

        // Вспомогательная функция: получить координаты точки на дуге
        const getPointOnArc = (deg) => {
            const rad = (deg * Math.PI) / 180;
            const x = centerX + radius * Math.cos(rad);
            const y = centerY - radius * Math.sin(rad);
            return { x, y };
        };

        // Строим SVG‑путь для одного сектора
        const buildSectorPath = (startDeg, endDeg) => {
            const start = getPointOnArc(startDeg);
            const end = getPointOnArc(endDeg);
            return `
                M ${centerX} ${centerY}
                L ${start.x} ${start.y}
                A ${radius} ${radius} 0 0 0 ${end.x} ${end.y}
                Z
            `;
        };

        // Количество секторов
        const sectorCount = angles.length - 1;

        return (
            <svg width={size} height={radius} viewBox={`0 0 ${size} ${radius}`}>
            {/* Рисуем все сектора */}
            {Array.from({ length: sectorCount }).map((_, i) => {
                const startDeg = angles[i];
                const endDeg = angles[i + 1];
                const fillColor = (i === highlightedIndex) ? highlightColor : baseColor;
                return (
                <path
                    key={i}
                    d={buildSectorPath(startDeg, endDeg)}
                    fill={fillColor}
                    style={{ fill: fillColor }} // для надёжности
                />
                );
            })}

            {/* Рисуем белые полоски поверх */}
            {angles.map((deg) => {
                const { x, y } = getPointOnArc(deg);
                const endX = centerX + (x - centerX) * tickLength;
                const endY = centerY + (y - centerY) * tickLength;
                return (
                <line
                    key={deg}
                    x1={centerX}
                    y1={centerY}
                    x2={endX}
                    y2={endY}
                    stroke={tickColor}
                    strokeWidth={strokeWidth}
                    style={{ stroke: tickColor }}
                />
                );
            })}
            </svg>
        );
    };


// function StatusDeal({ value, desc }) {

//     const statuses = [
//         { text: 'Прием', color: '#4CAF50', type: "pik_goods"},
//         { text: 'Движение', color: '#2196F3', type: "moving_deals" },
//         { text: 'Хранение', color: '#FF9800', type: "products_storage" },
//         { text: 'Отгрузка', color: '#9C27B0', type: "products_shipment" },
//         { text: 'Завершенная', color: '#F44336', type: "archive" },
//     ];

//     if (!value?.type) return null;


//     return (
//         <div
//         style={{
//             display: 'flex',
//             flexDirection: 'row',
//             alignItems: 'center',
//             justifyContent: 'center',
//         }}
//         >
//         {statuses.map((item, index) => {
//             // Определяем, является ли элемент активным (по типу)
//             const isActive = item.type === value.type;

//             return (
//             <div
//                 key={item.type} // лучше использовать type как key
//                 style={{
//                     width: isActive? "70px": "16px",
//                     height: isActive? "20px": "16px",
//                     backgroundColor: item.color,
//                     padding: '2px', // активный чуть крупнее
//                     color: '#fff',
//                     fontWeight: 'bold',
//                     fontSize: isActive ? '12px' : '9px',
//                     // transform: isActive ? 'scale(1.1)' : 'scale(1)',
//                     textAlign: 'center',
//                     opacity: isActive ? 1 : 0.5, // полупрозрачность для неактивных
//                 }}
//             >
//                 {isActive? item.text: ""}
//             </div>
//             );
//         })}
//         </div>
//     );
// }


function TzPrice({ value, desc, id, onChangeValue }) {
    const [count, setCount] = useState(0);
    const [changed, setChanged] = useState(false);

    useEffect(() => {
        if (value.TZV) {
            if (value.versions?.[value.TZV]) {
                setCount(value.versions[value.TZV].price)   
            }
            else setCount(0)
        }
    }, [value]);

    const handleInputChange = (event) => {
        if (event.target.value === '') {
            setCount(0);
            setChanged(true)
        }
        else {
            let tmp = parseInt(event.target.value, 10)
            if (!isNaN(tmp)) {
                setCount(tmp);
                setChanged(true)
            }
        }
    };

    const save = () => {
        setChanged(false)
        onChangeValue({ ...id, count, tzPrice: true});
    }
    
    if (!value || value.progress !== undefined || Object.keys(value.versions).length === 0) return <></>
    
    return (
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
            <MuiInput
                sx={{ ':after': { borderBottomColor: '#005b52' }}}
                value={count}
                size="medium"
                onChange={handleInputChange}
            />
            <IconButton 
                aria-label="copy" 
                onClick={() => save()} 
                style={{ marginTop: '0', marginLeft: '5px' }} 
                sx={{padding: '8px'}}>
                <SaveIcon
                    sx={{
                        transition: 'all 0.3s ease',
                        '&:hover': hoverStyle
                    }}
                />
            </IconButton>
        </div>
    );
}

// компонент для изменения количества товара
// @ts-ignore
function ProductCount({ value, desc, id, onChangeValue, fk = undefined, editable=true }) {
    const [count, setCount] = useState(0);

    useEffect(() => {
        console.log("VALUE AAAAAAAAA", value)
        if (value) {
            setCount(value)
        }
    }, [value]);

    const handleInputChange = (event) => {
        if (event.target.value === '') {
            setCount(0);
            onChangeValue({ ...id, count: 0, fk});
        }
        else {
            let tmp = parseInt(event.target.value, 10)
            if (!isNaN(tmp)) {
                setCount(tmp);
                onChangeValue({ ...id, count: tmp, fk});
            }
        }
    };
    // const handleBlur = () => {
    //     if (count < 0) {
    //         setCount(0);
    //         onChangeValue({ ...id, count: 0 });
    //     } 
    //     else{
    //         setCount(count);
    //         onChangeValue({ ...id, count: count });
    //     }
    // };

    return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
            <MuiInput
                sx={{ ':after': { borderBottomColor: '#005b52' }, width: '90%' }}
                value={count}
                size="medium"
                onChange={handleInputChange}
                disabled={!editable}
            />
        </div>
    );
}

function ProductCountWithUnitsType({ value, desc, id, onChangeValue, fk = undefined, editable=true}) {
    console.log("ProductCountWithUnitsType", value)
    const [count, setCount] = useState(0);
    const [UT, setUT] = useState("ед");

    useEffect(() => {
        
        if (value) {
            console.log("ProductCountWithUnitsType", value)
            if (Array.isArray(value)) {
                setCount(value[0])
                setUT(value[1]?.title || 'ед')
            }
            else {
                setCount(value)   
            }
        }
    }, [value]);

    const handleInputChange = (event) => {
        if (event.target.value === '') {
            setCount(0);
            onChangeValue({ ...id, count: 0, fk});
        }
        else {
            let tmp = parseInt(event.target.value, 10)
            if (!isNaN(tmp)) {
                setCount(tmp);
                onChangeValue({ ...id, count: tmp, fk});
            }
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end'}}>
            <MuiInput
                sx={{ ':after': { borderBottomColor: '#005b52' }, width: '100%', textAlign: 'right'}}
                value={count}
                size="medium"
                onChange={handleInputChange}
                disabled={!editable}
            />
            <Typography sx={{color: 'gray', fontSize: '12pt'}}>{UT}</Typography>
        </div>
    );
}

// @ts-ignore
function ProductCountEdit({ value, desc, id, onChangeValue, float }) {
    //Временно убрал крайнюю границу, но компонент оставлю 
    const [count, setCount] = useState(value || 0);


    const handleInputChange = (event) => {
        // if (event.target.value === '') {
        //     setCount(0);
        //     onChangeValue({ ...id, count: 0 });
        // }
        // else {
        //     let tmp = parseInt(event.target.value)
        //     if (!isNaN(tmp)) {
        //         setCount(tmp);
        //         onChangeValue({ ...id, count: tmp });
        //     }
        // }   


        if (event.target.value === '') {
            setCount(0);
            onChangeValue({ ...id, count: 0 });
        }
        else {
            if (float) {
                let tmp = undefined
                if (event.target.value[event.target.value.length -1] === '.') {
                    setCount(event.target.value);
                }
                else {
                    tmp = parseFloat(event.target.value)
                    if (!isNaN(tmp)) {
                    setCount(tmp);
                    onChangeValue({ ...id, count: tmp });
                    }
                }
            }
            else {
                let tmp = parseInt(event.target.value, 10)
                if (!isNaN(tmp)) {
                    setCount(tmp);
                    onChangeValue({ ...id, count: tmp });
                }
            }
        }
    };

    useEffect(() => {
        // if (value) setCount(value)
        if (float) {
            if (value) {
                let tmp = parseFloat(value)
                if (!isNaN(tmp)) {
                    setCount(tmp);
                }
                else {
                setCount(0)
                }
            }
            }
            else {
            if (value) {
                let tmp = parseInt(value, 10)
                if (!isNaN(tmp)) {
                    setCount(tmp);
                }
                else {
                setCount(0)
                }
            }
        }
    }, [value]);

    // const handleBlur = () => {
    //     if (count < 0) {
    //         setCount(0);
    //         onChangeValue({ ...id, count: 0 });
    //     } 
    //     else{
    //         setCount(count);
    //         onChangeValue({ ...id, count: count });
    //     }
    // };

    return (
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
            <MuiInput
                sx={{ ':after': { borderBottomColor: '#005b52' }, width: '80px' }}
                value={count}
                size="medium"
                onChange={handleInputChange}
            />
        </div>
    );
}

// @ts-ignore
function ProductCountEditKratCount({ value, desc, id, onChangeValue }) {
    //Временно убрал крайнюю границу, но компонент оставлю 
    const [count, setCount] = useState(value.err? 0: value.count || 0);

    useEffect(() => {
        console.log("ProductCountEditKratCount", value)
        if (value) setCount(value.count)
    }, [value]);


    // @ts-ignore
    const [inBox, setInBox] = useState(value.inBox || 0);
    const handleInputChange = (event) => {
        if (event.target.value === '') {
            setCount(0);
            onChangeValue({ ...id, count: 0 });
        }
        else {
            let tmp = parseInt(event.target.value)
            if (!isNaN(tmp)) {

                setCount(tmp);
                onChangeValue({ ...id, count: tmp });
            }
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', width:'100px' }}>
            <MuiInput
                sx={{ ':after': { borderBottomColor: '#005b52' }, width: '80px' }}
                value={count}
                size="medium"
                onChange={handleInputChange}
            />
            {/* Старые фишки, надо будет переработать или удалить */}
            {/* {inBox !==0 && <Typography style={{ color: count%inBox === 0? '#078376': '#ff0033', fontSize:"12px" }}>Кратность: {inBox}</Typography>}
            {value.err && <Typography style={{ color: count%inBox === 0? '#078376': '#ff0033', fontSize:"12px" }}>У товаров разная упаковка</Typography>} */}
        </div>
    );
}

// @ts-ignore
function ProductDim({ value, desc}) { 
    if (value) {    
        return (
            <div style={{ alignContent: "center",display: 'flex', flexDirection: 'column', 
            width: '100%'
            }}>
                <Typography variant='subtitle2' align='left'>Длина: {value.length}</Typography>
                <Typography variant='subtitle2' align='left'>Ширина: {value.width}</Typography>
                <Typography variant='subtitle2' align='left'>Высота: {value.height}</Typography>
            </div>
        );
    }
}

function ProductDimEditable({ value, desc, id, onChangeValue}) {

    const [size, setSize] = useState({width: 0, height: 0, length: 0})
    const [changed, setChanged] = useState(false)

    useEffect(() => {
        if (value) {
            setSize(value)
        }
    }, [value]);

    const edit = (feature, val) => {
        let tmp = JSON.parse(JSON.stringify(size))
        switch (feature) {
            case "w": {
                tmp.width = val
                break
            }
            case "h": {
                tmp.height = val
                break
            }
            case "l": {
                tmp.length = val
                break
            }
        }
        if (!_.isEqual(tmp, value)) {
            setChanged(true)
        }
        else {setChanged(false)}
        setSize(tmp)
    }

    const save = () => {
        setChanged(false)
        onChangeValue({...id, dim: size, size: true})
    }

    console.log("size", size)

    return (
        <div style={{ alignContent: "center",display: 'flex', flexDirection: 'column', width: '100%'}}>
            <NumInputDesign fontSize={'10pt'} title={"Длина"} val={size.length} onChange={(val) => {edit("l", val)}}/>
            <NumInputDesign fontSize={'10pt'} title={"Ширина"} val={size.width} onChange={(val) => {edit("w", val)}}/>
            <NumInputDesign fontSize={'10pt'} title={"Высота"} val={size.height} onChange={(val) => {edit("h", val)}}/>
            {changed && <Button variant="text" onClick={save} disabled={!changed} sx={{fontSize: '10pt'}}>
                Сохранить
            </Button>}
        </div>
    );    
        
    
}

function ConsumableCount({value}) {
    return (
            <div style={{ alignContent: "center",display: 'flex', flexDirection: 'column', 
            width: '100%'
            }}>
                {value[0] < 0?
                    <Typography sx={{ fontSize: '12pt', color: errorTextColor }}>{Math.floor(value[0])}</Typography>
                :
                    <Typography sx={{ fontSize: '12pt',  }}>
                        {Number.isInteger(value[0]) || value[1].kof === 1? value[0]: `${Math.trunc(value[0])} уп ${Math.round((value[0] - Math.trunc(value[0]))*value[1].kof)} ${value[1].title}` }
                    </Typography>
                }
                

            </div>
        );
}

// @ts-ignore
function ProductAllCount({ value, desc}) {
    console.log("value", value)

    const isMismatched = value && (value.countEtimated > 0 && value.countEtimated !== value.countProduct);
    const colorStyle = isMismatched ? 'red' : 'inherit';

    const isMismatched2 = value && (value.countDefect !== 0);
    const colorStyle2 = isMismatched2 ? 'red' : 'inherit';

    if (value) {     
        return (
            <div style={{ alignContent: "center",display: 'flex', flexDirection: 'column', width: '100%'}}>
                {value.countEtimated > 0 && 
                    <Typography variant='subtitle2' align='left'>Заявлено:&nbsp;
                        <Typography component="span" variant='subtitle2' sx={{ color: colorStyle }}>{value.countEtimated}</Typography>
                    </Typography>
                }

                <Typography variant='subtitle2' align='left'>Фактически:&nbsp;
                    {value.countProductHist? 
                        <Typography component="span" variant='subtitle2' sx={{ color: colorStyle }}>{value.countProduct}/{value.countProductHist}</Typography>
                        :
                        <Typography component="span" variant='subtitle2' sx={{ color: colorStyle }}>{value.countProduct}</Typography>
                    }
                </Typography>

                <Typography variant='subtitle2' align='left'>Брак:&nbsp;
                    <Typography component="span" variant='subtitle2' sx={{ color: colorStyle2 }}>{value.countDefect}</Typography>
                </Typography>
            </div>
        );
    }
}

// @ts-ignore
function PackageFeatures({ value, desc}) { //РЕДАЧИМ

    if (value) {    
        return (
            <div style={{ alignContent: "center",display: 'flex', flexDirection: 'column', 
            width: '100%'
            }}>
                <Typography variant='subtitle2' align='left'>Бирки: {value.labelsCount}</Typography>
                <Typography variant='subtitle2' align='left'>Крафт: {value.craftCount}</Typography>
                <Typography variant='subtitle2' align='left'>Флаеры: {value.bookletCount}</Typography>
                <Typography variant='subtitle2' align='left'>Запайка: {value.zapayka}</Typography>
            </div>
        );
    }
}

// @ts-ignore
function PackageTagsInfo({value, desc}){
    
    if (value) {  
        let resultString = '';
        for (let item of value) {
        const itemLine = `${item.name}: ${item?.count || 0} на ед товара`;

        if (resultString.length > 0) {
            resultString += '\n'; 
        }
        resultString += itemLine;
        }

        return (
            <div style={{ alignContent: "center",display: 'flex', flexDirection: 'column', width: '100%'}}>
            <Typography variant='body1' sx={{ whiteSpace: 'pre-line' }}>{resultString}</Typography>
            </div>
        );
    }
}

// import avatar from '../images/others/NoAvatar.png'
// компонент для отображения товара

// @ts-ignore
export function Product ({ value, desc }) {

    const [loading, setLoading] = useState(true);
    const [image, setImage] = useState(undefined)
    

    useEffect(() => {

        const loadPhoto = async (photoPath) => {
            let tmp = await getFile("png", { path: photoPath }); 
            setImage(typeof tmp === "string" ? tmp : '')
            setLoading(false)
        }

        if (value?.photo && value.photo.startsWith('/app/storage/')) {
            setLoading(true)
            loadPhoto(value.photo)
        }
        else {
            setImage(undefined)
            setLoading(false)
        }
    }, [value]);




    if (value) {

        //console.log('PRODUCT VALUE', value)
        
        if (value.type && value.type === "BOX") {
            return (
                // <UnarchiveIcon fontSize='large' />
                <img alt="" src={boxImg}  width={35} height={35}></img>
            );
        }

        let url = value?.url || undefined

        //иногда маркет не указан, так что ниже для обоих случаев

        if (value.market && !url){

            switch (value.market) {
                case "wb":
                    url = (value.nmID? `https://www.wildberries.ru/catalog/${value.nmID}/detail.aspx` : undefined)
                    break;

                case "ozon":
                    let ozonID = undefined
                    if (value.sizes){
                        ozonID = value?.sizes[0].ozonID
                    }else {
                        ozonID = value.urlID
                    }
                    url = (ozonID? `https://www.ozon.ru/product/${ozonID}/` : undefined)
                    break;
                    
                case "default":
                    break;
            }

        }else{
            url = (value.nmID === value.urlID? `https://www.wildberries.ru/catalog/${value.nmID}/detail.aspx` : `https://www.ozon.ru/product/${value.urlID}/`)
        }
        
        return (
            
            <div style={{
                alignContent: "center", 
                display: 'flex', 
                flexDirection: 'row', 
                alignItems: "center", 
                flexWrap: "wrap", 
                width: '100%'
            }}>
                <style>{`
                .product-link { 
                    color: #000; 
                    text-decoration: none; 
                }
                .product-link:hover { 
                    color: #078376; 
                    text-decoration: underline; 
                }
                `}</style>

                {loading? 
                    <div style={{width:70, height:105}}><Loading/></div>
                    :
                    <ImageFormatProduct value={image || value.photo} />
                }
                
                <div style={{ display: 'flex', flexDirection: 'column', maxWidth: "180px", marginLeft: '10px' }}>
                    <Typography variant='subtitle2' align='left'>{value.brand}</Typography>
                    
                    {/* Оборачиваем название в ссылку */}
                    <Typography variant='subtitle2' align='left'>
                        {url ?(
                            <a 
                            href={value?.url || url} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="product-link"
                            >
                            {value.title}
                            </a>
                        ) : (
                            // Если url пустой, null или undefined — просто выводим текст
                            value.title
                        )}
                    </Typography>
                    {/* {value.showSize && <Typography variant='subtitle2' align='left'>{value.showSize}</Typography>} */}
                </div>
            </div>
        );
    }
}

export function ProductMoreInfoProducts ({ value }) {
    if (value) {
        return (<ProductMoreInfo value={value}/>)
    }
    else {
        return(
            <Button 
                variant="text" 
                sx={{
                    width: "100%",
                    height: "105px",
                    textTransform: "none",
                    fontSize: "24px",
                    borderRadius: "10px",
                    borderColor: buttonColor,
                    borderStyle: 'solid',
                    borderWidth: '2px',
                    justifyContent: "center",   // выравнивание текста по левому краю
                    padding: 0,                 // убираем отступ слева, чтобы текст начинался с самого края
                    margin: 0,
                    "&:hover": {
                        backgroundColor: "transparent", // фон не меняется
                        color: buttonColorHover,          // подсветка текста (можно заменить на нужный цвет)
                        borderColor: buttonColorHover,
                    },
                    "&:active": {
                        backgroundColor: "transparent",
                    },
                    "&:focus": {
                        backgroundColor: "transparent",
                    },
                }}
            >
                +
            </Button>
        )
    }
}

export function ProductMoreInfo ({ value }) {

    const [loading, setLoading] = useState(true);
    const [image, setImage] = useState(undefined)
    const [exp, setExp] = useState(false)
    

    useEffect(() => {

        const loadPhoto = async (photoPath) => {
            let tmp = await getFile("png", { path: photoPath }); 
            setImage(typeof tmp === "string" ? tmp : '')
            setLoading(false)
        }

        if (value?.photo && value.photo.startsWith('/app/storage/')) {
            setLoading(true)
            loadPhoto(value.photo)
        }
        else {
            setImage(undefined)
            setLoading(false)
        }
    }, [value]);




    if (value) {

        //console.log('PRODUCT VALUE', value)
        
        if (value.type && value.type === "BOX") {
            return (
                // <UnarchiveIcon fontSize='large' />
                <img alt="" src={boxImg}  width={35} height={35}></img>
            );
        }

        let url = value?.url || undefined

        //иногда маркет не указан, так что ниже для обоих случаев

        if (value.market && !url){

            switch (value.market) {
                case "wb":
                    url = (value.nmID? `https://www.wildberries.ru/catalog/${value.nmID}/detail.aspx` : undefined)
                    break;

                case "ozon":
                    let ozonID = undefined
                    if (value.sizes){
                        ozonID = value?.sizes[0].ozonID
                    }else {
                        ozonID = value.urlID
                    }
                    url = (ozonID? `https://www.ozon.ru/product/${ozonID}/` : undefined)
                    break;
                    
                case "default":
                    break;
            }

        }else{
            url = (value.nmID === value.urlID? `https://www.wildberries.ru/catalog/${value.nmID}/detail.aspx` : `https://www.ozon.ru/product/${value.urlID}/`)
        }
        
        return (
            
            <div style={{
                alignContent: "center", 
                display: 'flex', 
                flexDirection: 'row', 
                alignItems: "center", 
                // flexWrap: "wrap", 
                width: '100%'
            }}>
                <style>{`
                .product-link { 
                    color: #000; 
                    text-decoration: none; 
                }
                .product-link:hover { 
                    color: #078376; 
                    text-decoration: underline; 
                }
                `}</style>

                {loading? 
                    <div style={{width:70, height:105}}><Loading/></div>
                    :
                    <ImageFormatProduct value={image || value.photo} />
                }
                
                <div style={{ display: 'flex', flexDirection: 'column', maxWidth: "calc(100% - 90px )", marginLeft: '10px' }}>
                    {/* <Typography variant='subtitle2' align='left'>{value.brand}</Typography> */}
                    
                    {/* Оборачиваем название в ссылку */}
                    <Tooltip 
                        title={value.title}
                        slotProps={{
                            popper: {
                                modifiers: [
                                    {
                                    name: 'offset',
                                    options: {
                                        offset: [100, -50], // [горизонталь, вертикаль]. Положительное число отдаляет.
                                    },
                                    },
                                ],
                            },
                        }}
                    >
                        <Typography align='left' 
                            sx={{
                                fontSize: '12pt',
                                lineHeight: '13pt',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                            }}
                        >
                            {url ?(
                                <a 
                                href={value?.url || url} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="product-link"
                                >
                                {value.title}
                                </a>
                            ) : (
                                // Если url пустой, null или undefined — просто выводим текст
                                value.title
                            )}
                        </Typography>
                    </Tooltip>
                    <Typography sx={{fontSize: '11pt', lineHeight: '11pt', marginTop: '2px', marginBottom: '2px', fontWeight: 'bold'}}>{value.barcode}</Typography>
                    <Typography sx={{fontSize: '10pt', color: 'gray', lineHeight: '10pt', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical'}}>Бренд: {Array.isArray(value.brand)? value.brand.join(', '): value.brand}</Typography>
                    <Typography sx={{fontSize: '10pt', color: 'gray', lineHeight: '10pt', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical'}}>АРТ: {Array.isArray(value.vendorCode)? value.vendorCode.join(', '): value.vendorCode}</Typography>
                    <Typography sx={{fontSize: '10pt', color: 'gray', lineHeight: '10pt', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical'}}>Размер: {Array.isArray(value.sizeTitle)? value.sizeTitle.join(', '): value.sizeTitle}</Typography>
                    <Typography sx={{fontSize: '10pt', color: 'gray', lineHeight: '10pt', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical'}}>Цвет: {Array.isArray(value.color)? value.color.join(', '): value.color}</Typography>
                    {/* {value.showSize && <Typography variant='subtitle2' align='left'>{value.showSize}</Typography>} */}
                </div>
            </div>
        );
    }
}

// @ts-ignore
function Consumable({ value, desc }) { 
    const [loading, setLoading] = useState(false);
    const [photo, setPhoto] = useState('');

    useEffect(() => {
        let isMounted = true;
        if (!value.data?.photo && !value.photo && !value.data?.blob && !value.blob) {
            setPhoto('');
            setLoading(false);
            return;
        }

        const loadPhoto = async () => {
            const directBlob = value.data?.blob || value.blob;

            if (directBlob) {
                if (isMounted) {
                    setPhoto(directBlob);
                    setLoading(false);
                }
                return;
            }
            const photoPath = value.data?.photo || value.photo;
            if (!photoPath) {
                if (isMounted) setPhoto('');
                return;
            }
            try {
                if (isMounted) setLoading(true);
                let img = await getFile("png", { path: photoPath }); 
                
                if (isMounted) {
                    setPhoto(typeof img === "string" ? img : '');
                }
            } catch (err) {
                console.error(err);
                if (isMounted) setPhoto('');
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        loadPhoto();

        return () => { isMounted = false; };
    }, [value.data?.photo, value.photo, value.data?.blob, value.blob, value.id]);

    if (!value) return null;

    if (value.type === "BOX") {
        return <img alt="" src={boxImg} width={35} height={35}></img>
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: "center", width: '100%', gap: '10px' }}>
            <div style={{ width: 70, height: 105, flexShrink: 0, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {loading ? (
                    <Loading />
                ) : photo ? (
                    <ImageFormatProduct value={photo} />
                ) : (
                    <img src={NoPhoto} alt="no photo" style={{ width: '100%', height: '100%', objectFit: 'contain', opacity: 0.5 }} />
                )}
            </div>
            
            <div style={{ display: 'flex', flexDirection: 'column', maxWidth: '80%' }}>
                <Typography variant='subtitle2' align='left' fontWeight="bold">
                    {value.title || '-'}
                </Typography>
            </div>
        </div>
    );
}

export function ConsumType({ value}) { //РЕДАЧИМ
    if (value !== undefined){
        let text = ""
        switch (value) {
            case "pack": 
                text = "Упаковка"
                break
            case "other": 
                text = "Для комплектации"
                break
            case "additional": 
                text = "Дополнительный"
                break
        }
        return (
        <div style={{display: 'flex', 
            width: '100%',
        }}>
            <Typography variant="subtitle2">{text}</Typography>
        </div>
    )}
}

// @ts-ignore
function HowMove({ value, desc }) {
    // console.log(value);
    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Typography variant='subtitle2' align='left'>Сделка: {value.deal}</Typography>
            {value.box === "0"? 
                <Typography variant='subtitle2' align='left'>Не привязан</Typography>:
                <Typography variant='subtitle2' align='left'>Короб: {value.box}</Typography>
            }
            {value.count && <Typography variant='subtitle2' align='left'>Количество: {value.count}</Typography>}
            {value.addr && <Typography variant='subtitle2' align='left'>Адрес: {value.addr}</Typography>}
        </div>
    );
}

// @ts-ignore
function HowMoveInfo({ value, desc }) {

    // console.log("HowMoveInfo", value);
    
    
    if (value) {

        let formattedSize = undefined
        if (value.sizeTitle) {
            formattedSize = value.sizeTitle
            .replace(/-/g, '\u2011')    
            .replace(/\//g, '/\u200b');
        }

        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Typography variant='subtitle2' align='left'>{value.barcode}</Typography>
                <Typography variant='subtitle2' align='left'>АРТ: {value.vendorCode}</Typography>
                <Typography variant='subtitle2' align='left'>Цвет: {value.color}</Typography>
                <Typography variant='subtitle2' align={'left'}>Размер:{formattedSize}</Typography>
            </div>
        );
    }

}

function MovingGuide({ value }) {
    // console.log(value);
    if (value) {
        return (
            <Tooltip title={"Сделка сборная"} arrow placement="top">
                <ListAltIcon/>
            </Tooltip>
        )
    }
    return (<></>);
}

export function DealDetails({ value }) {
    console.log("DealDetails", value);
    if (value) {
        return (
            <div style={{width: "100%", display: "flex", flexDirection:'row', justifyContent: "space-between"}}>
                {value.combined && 
                    <Tooltip title={"Сделка с хранения"} arrow placement="top">
                        <ListAltIcon onClick={value.actions?.combined || (() => {console.log("NO ACTION")})} sx={{ color: 'gray', height: '24px', width: '24px', '&:hover': value.actions?.combined? hoverStyle: undefined}}/>
                    </Tooltip>
                }
                {value.defect && 
                    <Tooltip title={"Брак"} arrow placement="top">
                        <Box onClick={value.actions?.defect || (() => {console.log("NO ACTION")})} sx={{height: '24px', width: '24px', '&:hover': value.actions?.defect? hoverStyle: undefined}}>
                            <img src={defectIcon} style={{height: '100%', width: '100%'}}></img>
                        </Box>
                    </Tooltip>
                }
                {value.ret && 
                    <Tooltip title={"Возврат"} arrow placement="top">
                        <KeyboardBackspaceIcon onClick={value.actions?.ret || (() => {console.log("NO ACTION")})} sx={{ color: 'gray', height: '24px', width: '24px', '&:hover': value.actions?.ret? hoverStyle: undefined}}/>
                    </Tooltip>
                }
                {value.selfret && 
                    <Tooltip title={"Самовыкуп"} arrow placement="top">
                        <ReplayIcon onClick={value.actions?.selfret || (() => {console.log("NO ACTION")})} sx={{ color: 'gray', height: '24px', width: '24px', '&:hover': value.actions?.selfret? hoverStyle: undefined}}/>
                    </Tooltip>
                }
                {value.mtm &&
                    <Box onClick={value.actions?.selfret || (() => {console.log("NO ACTION")})} sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', '&:hover': value.actions?.selfret? hoverStyle: undefined}}>
                        <ImgMagazine magazine={value.mtm.old} size={'20px'} user_id={value.mtm.uid}/>
                        <ArrowRightAltIcon style={{ color: 'gray', height: '24px', width: '24px'}}/>
                        <ImgMagazine magazine={value.mtm.new} size={'20px'} user_id={value.mtm.uid}/>
                    </Box>
                }
            </div>
        )
    }
    return (<></>);
}


// компонент для отображения услуги
// @ts-ignore
function Service({ value, desc }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <div style={{ marginRight: '5px', width: '16px', height: '16px', backgroundColor: value?.color || colors.elements }}></div>
            <Typography variant='subtitle2'>{value?.name}</Typography>
        </div>
    );
}

// отображение имении пдф файла
// @ts-ignore
function PdfFile({ value, desc, onClickRow}) {
    return (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start'}} onClick={onClickRow}>
            <Typography variant="subtitle1" fontWeight="bold" onClick={onClickRow}>
                {value}
            </Typography>
        </div>
    );
}

//Новый компонент для переноса в зависимости от количества символов в строке
const groupItemsByLimit = (text, limit = 15) => {
    if (!text) return [];

    // Разбиваем строку на отдельные размеры (по запятой с пробелом)
    const items = text.split(', '); 
    const groupedLines = [];
    let currentLine = '';
    const separator = ', '; // Новый разделитель внутри сгруппированной строки

    for (const item of items) {
        // Длина нового элемента, который будет добавлен к текущей строке
        // Это: Длина текущей строки + Длина разделителя (если не первая) + Длина нового элемента
        const newSegmentLength = item.length + (currentLine.length > 0 ? separator.length : 0);
        const newTotalLength = currentLine.length + newSegmentLength;

        if (newTotalLength <= limit) {
            // Если помещается: добавляем разделитель, если строка не пуста
            if (currentLine.length > 0) {
                currentLine += separator; 
            }
            currentLine += item;
        } else {
            // Если не помещается:
            
            // 1. Сохраняем готовую строку (если она не пустая)
            if (currentLine.length > 0) {
                groupedLines.push(currentLine);
            }
            // 2. Начинаем новую строку с текущего элемента (он становится первым, разделитель не нужен)
            currentLine = item;
        }
    }

    // Добавляем последнюю незавершенную строку
    if (currentLine.length > 0) {
        groupedLines.push(currentLine);
    }

    return groupedLines;
};

// @ts-ignore
function ProductSize({ value, desc }) { //РЕДАЧИМ
    
    // Группируем элементы, чтобы ни один сегмент не превышал 15 символов
    const segments = groupItemsByLimit(value.title, 15); 

    if (value){
    return (
        <div style={{display: 'flex', flexDirection: 'column',
                    width: '100%'
                    }}>
            {segments.map((segment, index) => (
                <Typography 
                    key={index}
                    variant="subtitle1" 
                    fontWeight="bold"
                    style={{ 
                        lineHeight: '1.2',
                        whiteSpace: 'nowrap' 
                    }} 
                >
                    {segment}
                </Typography>
            ))}
        </div>
    );}
}

// отображение остатков в выдвижном элементе
const AccordionItemStocks = ({ child, data }) => {

    // const $data = data.sort((a, b) => (a.stocks > b.stocks ? -1 : b.stocks > a.stocks ? 1 : 0));
    const $data = data


    // console.log("STOCKS", $data)
    const [active, setActive] = useState(false);

    const handleItemClick = () => {
        setActive(!active);
    };
    return (
        <div className="wrapper" >
            <div className="answer-content" onClick={handleItemClick} style={{display:'flex', flexDirection:"row"}}>
                {child}
                {$data.length >0 && <>{active ? <KeyboardArrowUpIcon/>: <KeyboardArrowDownIcon />}</>}
            </div>
            <div className="answer-container">
                {active && 
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    {$data.map((el, index) => (
                        <Typography key={index} variant="subtitle2" component="div">
                            {el.name && <span>{el.name}: </span>}
                            <span style={{ fontStyle: 'italic', marginLeft: '4px' }}>
                                {el.stocks}
                            </span>
                        </Typography>
                    ))}
                </div>
                }
            </div>
        </div>
    )
}

// @ts-ignore
function ProductStocksTable({value, desc}) { //РЕДАЧИМ
    // console.log("ProductStocksTable", value)
    if (value){
    return (
        <div style={{
            width: '100%', 
            display: 'flex', flexDirection: "column", alignContent: "center" }}>
            <Box sx={{
                '&:hover': {
                    cursor: 'pointer'
                }
            }} >
                <AccordionItemStocks 
                    data={value.stocks} 
                    child={
                        <Typography variant="subtitle2" fontWeight="bold" fontStyle='normal' sx={{height:"30px"}}>
                            Итого: {value.total}
                        </Typography>
                    }>
                </AccordionItemStocks>
            </Box>
        </div>
    );}
}

// @ts-ignore
function ProductStocksTableBig({value, desc}) { //РЕДАЧИМ
    // console.log("ProductStocksTable", value)
    if (value){
    return (
        <div style={{
            width: '100%',
            display: 'flex', flexDirection: "column", alignContent: "center" }}>
            <Box sx={{
                '&:hover': {
                    cursor: 'pointer'
                }
            }} >
                <AccordionItemStocks 
                    data={value.stocks} 
                    child={
                        <Typography variant="subtitle2" fontWeight="bold" fontStyle='normal' sx={{height:"40px"}}>
                            Итого: {value.total}
                        </Typography>
                    }>
                </AccordionItemStocks>
            </Box>
        </div>
    );}
}

// @ts-ignore
function DealProductsAllInfo({value, desc, noEtimated = false, noRemains = false}) {
    //console.log("value", value)
    if (value){
    return (
        <div style={{
            width: '100%',
            display: 'flex', flexDirection: "column", alignContent: "center" }}>
            <Box sx={{
                '&:hover': {
                    cursor: 'pointer'
                }
            }} >
                <AccordionItemProductsAllInfo 
                    data={value} 
                    child={
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', minWidth:'200px', width:'95%'}}>
                            <Typography variant="subtitle2" fontWeight="bold" fontStyle='normal' sx={{height:"20px", marginRight: "5px"}}>
                                SKU: {value.products.length}
                            </Typography>
                            <Typography variant="subtitle2" fontWeight="bold" fontStyle='normal' sx={{height:"20px"}}>
                                Количество: {value.counts.all}
                            </Typography>
                        </div>
                    }
                    noRemains={noRemains}
                    noEtimated={noEtimated}
                >
                </AccordionItemProductsAllInfo>
            </Box>
        </div>
    );}
}

const AccordionItemProductsAllInfo = ({ child, data, noRemains = false, noEtimated = false}) => {
  const $data = data;

  const parentRef = useRef(null);  
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = () => {
    setAnchorEl(parentRef.current);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div ref={parentRef} style={{ display: "flex", alignItems: "center" }}>
      {child}

      <Tooltip title={"Список товаров"}>
        <IconButton
          size="small"
          onClick={handleClick}
          style={{
            padding: "4px",
            border: "0px solid",
            borderRadius: "5px",
            color: "#424242",
            maxHeight: "30px",
            maxWidth: "30px",
            marginLeft: "8px",
          }}
        >
          {open ? (
            <KeyboardArrowUpIcon sx={{ fontSize: 18 }} />
          ) : (
            <KeyboardArrowDownIcon sx={{ fontSize: 18 }} />
          )}
        </IconButton>
      </Tooltip>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          style: {
            padding: "12px",
            width: "max-content",
            maxWidth: "90vw",
            marginTop: "5px",
            borderRadius: "12px",
            // marginLeft: "-5px",
            maxHeight: "400px",
            overflowY: "auto",
            overflowX: "hidden",
          },
        }}
      >
        <TableContainer sx={{ maxHeight: 400 }}>
            <Table stickyHeader size="small">
                <TableHead>
                <TableRow>
                    <TableCell sx={{ fontWeight: 'bold', borderBottom: "0px"}}>Товар</TableCell>
                    {!noEtimated && <TableCell align="center" sx={{ fontWeight: 'bold', borderBottom: "0px" }}>Заявлено</TableCell>}
                    <TableCell align="center" sx={{ fontWeight: 'bold', borderBottom: "0px" }}>Фактически</TableCell>
                    {!noRemains && <TableCell align="center" sx={{ fontWeight: 'bold', borderBottom: "0px" }}>Остаток</TableCell>}
                </TableRow>
                </TableHead>
                <TableBody>
                {$data.products.map((el, index) => (
                    <TableRow key={index} hover={false} sx={{ '& > *': { borderBottom: 'none' } }}>
                        {/* Левая ячейка: название жирным, под ним артикул и размер */}
                        <TableCell sx={{ borderBottom: "0px" }}>
                            <Tooltip title={el.title}>
                                <Typography
                                    variant="body2"
                                    fontWeight="bold"
                                    sx={{ wordBreak: 'break-word', whiteSpace: 'normal' }}
                                >
                                    {el.title}
                                </Typography>
                            </Tooltip>
                            <Typography variant="caption" color="text.secondary">
                                Арт: {el.vendorCode} &nbsp;|&nbsp; Размер: {$data.sizes[index]}
                            </Typography>
                        </TableCell>

                        {/* Заявленное количество — крупный шрифт, по центру, без "ед." */}
                        {!noEtimated && 
                            <TableCell align="center" sx={{ borderBottom: "0px" }}>
                                <Typography fontSize={"20px"}>
                                    {$data.counts.list[index].countEtimated ?? $data.counts.list[index]}
                                </Typography>
                            </TableCell>
                        }

                        {/* Фактическое количество — крупный шрифт, по центру, без "ед." */}
                        <TableCell align="center" sx={{ borderBottom: "0px" }}>
                            <Typography fontSize={"20px"}>
                                {$data.counts.list[index].countProductHist || $data.counts.list[index].countProduct || 0}
                            </Typography>
                        </TableCell>
                        {/* Остаток — крупный шрифт, по центру, без "ед." */}
                        {!noRemains && 
                            <TableCell align="center" sx={{ borderBottom: "0px" }}>
                                <Typography fontSize={"20px"}>
                                    {$data.counts.list[index].countProduct || 0}
                                </Typography>
                            </TableCell>
                        }
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>
      </Popover>
    </div>
  );
};


// @ts-ignore
function DealProducts({value, desc}) {
    //console.log("value", value)
    if (value){
    return (
        <div style={{
            width: '100%',
            display: 'flex', flexDirection: "column", alignContent: "center" }}>
            <Box sx={{
                '&:hover': {
                    cursor: 'pointer'
                }
            }} >
                <AccordionItemProducts 
                    data={value.products} 
                    child={
                        <div>
                            <Typography variant="subtitle2" fontWeight="bold" fontStyle='normal' sx={{height:"20px"}}>
                                SKU: {value.products.length}
                            </Typography>
                        </div>
                    }>
                </AccordionItemProducts>
            </Box>
        </div>
    );}
}

// @ts-ignore
function DealProductsSizes({value, desc}) {
    if (value){
    return (
        <div style={{
            width: '100%',
            display: 'flex', flexDirection: "column", alignContent: "center" }}>
            <Box sx={{
                '&:hover': {
                    cursor: 'pointer'
                }
            }} >
                <AccordionItemProducts 
                    data={value.sizes} 
                    child={
                        <div style={{height:"20px"}}>
                        </div>
                    }>
                </AccordionItemProducts>
            </Box>
        </div>
    );}
}

// @ts-ignore
function DealProductsCount({value, desc}) {
    if (value){
    return (
        <div style={{
            width: '100%',
            display: 'flex', flexDirection: "column", alignContent: "center" }}>
            <Box sx={{
                '&:hover': {
                    cursor: 'pointer'
                }
            }} >
                <AccordionItemProducts 
                    data={value.list} 
                    child={
                        <div>
                            <Typography variant="subtitle2" fontWeight="bold" fontStyle='normal' sx={{height:"20px"}}>
                                Итого: {value.all}
                            </Typography>
                        </div>
                    }>
                </AccordionItemProducts>
            </Box>
        </div>
    );}
}

const AccordionItemProducts = ({ child, data }) => {

    const $data = data

    const [active, setActive] = useState(false);

    const handleItemClick = () => {
        setActive(!active);
    };
    const contentHeight = useRef(null)
    return (
        <div className="wrapper" >
            <div className="answer-content" onClick={handleItemClick} style={{display:'flex', flexDirection:"row", alignItems: "center"}}>
                {child}
                {$data.length >0 && <>{active ? <KeyboardArrowUpIcon/>: <KeyboardArrowDownIcon />}</>}
            </div>
            <div ref={contentHeight} className="answer-container" style={
                active
                    // @ts-ignore
                    ? { height: contentHeight.current.scrollHeight }
                    : { height: "0px" }
            }>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    {$data.map((el) => (
                        <Tooltip title={el}>
                            <Typography variant="subtitle2">
                                {String(el).length > 20 ? `${String(el).substring(0, 20)}...` : el}:
                            </Typography>        
                        </Tooltip>
                    ))}
                </div>
            </div>
        </div>
    )
}

function TitledList({value}) {
    // console.log("ProductStocksTable", value)
    if (value){

        return (
            <div style={{ width: '100%', display: 'flex', flexDirection: "column", alignContent: "center" }}>
                <Typography variant="subtitle2" fontWeight="bold" fontStyle='normal' sx={{height:"30px"}}>
                    {value.title}
                </Typography>
                {value.items.map((el) => (
                    <Typography variant="subtitle2">
                        {el}
                    </Typography>
                ))}
            </div>
        );}
}



// @ts-ignore
function ProductStocks({value, desc}) {
    return (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start'}}>
            <Typography variant="subtitle1" fontWeight="bold">
                {value.stocks}
            </Typography>
        </div>
    );
}

function RTImage({ value}) {
    // console.log("value0", value)
    return (
        <img src={value} style={{ width: '53mm', height: '37mm'}} />
    );
}



function UsedQRForCli({ value, desc }) {
    console.log("value", value)
    return (
        <div style={{width: '100%', display: 'flex', flexDirection: 'column', }}>
            <ImageBufferMemo 
                // @ts-ignore
                value={value.image}
            />
            {/* <Typography sx={{fontSize: '12pt'}}>Использован в сделке:</Typography> */}
            {value.deal && <Typography sx={{fontSize: '12pt'}}>Использован в сделке: {value.deal.cdn}</Typography>}
        </div>
    );
}

// отображение страниц пдф файла
// @ts-ignore
function ImageBuffer({ value, desc }) {
    // console.log("value0", value)
    console.log("value", value)
    return (
        <ImageBufferMemo 
// @ts-ignore
        value={value}></ImageBufferMemo>
    );
}
// загрузка каждой страницы пдф файла в отдельный canvas
// для оптимизации производительности и избежания проблем с памятью
// используется React.memo для предотвращения повторного рендеринга при неизменных данных
const ImageBufferMemo = React.memo((value) => {
    const canvasRef = useRef(null);
    useEffect(() => {
        const loadPage = async () => {
            // console.log(value);
            // @ts-ignore
            const viewport = value.value.getViewport({ scale: 2.0 });
            const canvas = canvasRef.current;
            const context = canvas.getContext("2d");
            canvas.width = viewport.width;
            canvas.height = viewport.height;
            // @ts-ignore
            await value.value.render({ canvasContext: context, viewport }).promise;
        }
        loadPage();

    }, [])
    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: 2 }}>
            <canvas ref={canvasRef} style={{ maxWidth: "100%", border: "1px solid #ddd" }} />
        </div>
    );
});

// кнопка для загрузки пдф файлов QR кодов
// @ts-ignore
export function UploadQrButton({ value, desc, size = "64px", inmarket = 'custom', color = '#898888', textColor = 'black', animate = true}) {

    //console.log("QR value", value)
    //console.log("desc", desc)

    const { market } = useSelector(MarketClientSelector);

    const [open, setOpen] = useState(false);
    const [count, setCount] = useState(0)

    useEffect(() => {
        if (value?.count !== undefined) {
            setCount(value.count);
        }
    }, [value]);

    console.log("AAAA", inmarket, market)

    if (value && 'progress' in value) { 
        return (
            <div style={{width: "100%", display: 'flex', flexDirection: "column", alignItems: 'center'}}>
                <div style={{width: `calc(${size} + 6px )`, height: `calc(${size} + 41px )`, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                    <CircularProgressWithLabel value={value.progress} />
                </div>
            </div>
        );
    } 

    return (
        <div style={{display: "flex", flexDirection: 'column', alignItems: 'center', width: '100%'}}>
            <QrCode2Icon
                onClick={()=>setOpen(true)}
                sx={{
                    width: size,
                    height: size,
                    borderColor: '#BDBDBD',
                    color,
                    textTransform: 'none',
                    whiteSpace: 'normal',
                    fontSize: '0.8rem',
                    alignContent: "center",
                    transition: animate? 'all 0.3s ease': undefined,
                    '&:hover': animate? hoverStyle: undefined
                }}
            />
            <Typography sx={{color:textColor}}>{count}</Typography>
            <Dialog
                open={open}
                maxWidth='lg'
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setOpen(false) }}
            >
                <div style={{ height: '650px', width: '1000px', padding: '12px' }}>
                    <AddQrCode
                        close={()=>{setOpen(!open)}} 
                        dataProduct={value}
                        market={inmarket || market}
                    />
                </div>

            </Dialog>
        </div>
    );
};

// форматер для обрезки текста
// @ts-ignore
const truncateText = (text, maxLength) => {
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };




//Функция для генерации следующей версии тз
export function getNextItem(list) {
    // Если 'main' отсутствует, следующим должен быть 'main'
    if (!list.includes('main')) {
        return 'main';
    }

    // Собираем номера из всех элементов 'alt_N'
    const existingNumbers = new Set(); // используем Set для автоматической уникальности
    for (const item of list) {
        if (item.startsWith('alt_')) {
            const num = parseInt(item.slice(4), 10);
            if (!isNaN(num)) {
                existingNumbers.add(num);
            }
        }
    }

    // Ищем наименьший положительный номер, начиная с 1, который отсутствует
    let nextNum = 2;
    while (existingNumbers.has(nextNum)) {
        nextNum++;
    }

    return `alt_${nextNum}`;
}

// кнопка для технического задания
// @ts-ignore
export function UploadTechTaskButton({ value, desc, id, onChange, onClickRow = () => {}, onlyVersions = false}) {
    console.log("UploadTechTaskButton", desc)
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [services, setServices] = useState([])
    const [versions, setVersions] = useState(["main"])
    const [version, setVersion] = useState("main")
    /** @type {[any, Function]} */
    const [preCreateCopy, setPreCreateCopy] = useState(undefined)
    
    let actualText = value?.versions?.[value.TZV || 'main']?.text || ""
    let actualServices = value?.versions?.[value.TZV || 'main']?.services || []
    let actualPrint = value?.versions?.[value.TZV || 'main']?.print || "classic"
    let actualComment = value?.versions?.[value.TZV || 'main']?.comment || ""
    let actualFBS = value.version?.[value.TZV || 'main']?.fbs || false
    let actualHide = value.version?.[value.TZV || 'main']?.hide || false

    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleOpenServices = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseServices = () => {
        setAnchorEl(null);
    };

    const openService = Boolean(anchorEl);
    // const [text, setText] = useState(null);
    //console.log('Check: ',value,'Text:', actualText)

    //console.log('UPLOAD TECH', value)

    const closeWindow = ()=>{
        onChange({...id, text: actualText, services: actualServices, print: actualPrint, comment:actualComment, fbs:actualFBS, version: version, hide: actualHide});
        setOpen(false)
    }

    const copyToOther = ()=>{
        onChange({
            ...id, 
            text: value?.versions?.[version]?.text, 
            services: value?.versions?.[version]?.services, 
            print: 'classic',//'value?.versions?.[version]?.print, 
            comment:value?.versions?.[version]?.comment, 
            fbs:value?.versions?.[version]?.fbs,
            hide:false,
            version: version,
            copy: true
        });
    }

    const {company_id } = useSelector(
        loginSelector
    );


    //Не очень хорошо постоянно запрашивать заного, надо подумать, как правильно сделать
    useEffect(() => {
        const fetchData = async () => {
            try{
                setLoading(true)
                const responseData = await get('Handbook/getOnName', {company_id, name: "services"});
                //console.log(responseData)
                if (responseData.message?.[0].data) {
                    let $data = JSON.parse(responseData.message[0].data)
                    //console.log("$data", $data)
                    if ($data.values) {
                        setServices($data.values)
                    }
                }
            }
            catch {}
            finally {setLoading(false)}

        }

        fetchData();
    }, []);

    useEffect(() => {
        if (value.versions) {
            let tmp = Object.keys(value.versions)
            setVersions(tmp)
            if (tmp.length >0) {setVersion(tmp[0])}
        }
        if (value.TZV) {
            setVersion(value.TZV)
        }
    }, [value]);

    // @ts-ignore
    const changeText = (text, services, print, sv, comment, fbs, hide=false)=>{
        actualText = text
        actualServices = services
        actualPrint = print
        actualComment = comment
        actualFBS = fbs
        actualHide = hide
    }

    const changeVersion = (v) => {
        setVersion(v)
        onChange({...id, swap:v});
        actualText = value?.versions?.[v]?.text || ""
        actualServices = value?.versions?.[v]?.services || ""
        actualPrint = value?.versions?.[v]?.print || "classic"
        actualComment = value?.versions?.[v]?.comment || ""
        actualFBS = value?.versions?.[v]?.fbs || false
        actualHide = value?.versions?.[v]?.hide || false
    }

    const addVer = () => {
        
        //Создаем копию на всякий
        let old = JSON.parse(JSON.stringify({
            actualText,
            actualServices,
            actualPrint,
            actualComment,
            actualFBS,
            version,
            versions
        }))
        setPreCreateCopy(old)

        actualText = ""
        actualServices = ""
        actualPrint = "classic"
        actualComment = ""
        actualFBS = false
        
    
        let name = getNextItem(Object.keys(value.versions))

        onChange({...id, swap:name});
        setVersion(name)
        setVersions([...versions, name])
        setOpen(true)
    }    


    const cancelEdit = () => {
        if (preCreateCopy) {
            actualText = preCreateCopy.actualText
            actualServices = preCreateCopy.actualServices
            actualPrint = preCreateCopy.actualPrint
            actualComment = preCreateCopy.actualComment
            actualFBS = preCreateCopy.actualFBS

            onChange({...id, swap:preCreateCopy.version});
            setVersion(preCreateCopy.version)
            setVersions(preCreateCopy.versions)
        }
        setPreCreateCopy(undefined)
        setOpen(false)
    }

    const titleVersion = (v) => {
        if (v) {
            return (
                <Typography variant="subtitle2" >
                    {v === 'main'? `ТЗ 1`: v === 'defect'? "Брак": v.split('_')[0] === 'alt'? `ТЗ ${v.split('_')[1]}`: `Неизвестное ТЗ`}
                </Typography>
            )
        }
        else {
            return (
                <Typography variant="subtitle2" >
                    {`Неизвестное ТЗ`}
                </Typography>
            )
        }
    }

    const getTitleVersionText = (v) => {
        if (v) {
            return v === 'main'? `ТЗ 1`: v === 'defect'? "Брак": v.split('_')[0] === 'alt'? `ТЗ ${v.split('_')[1]}`: `Неизвестное ТЗ`
        }        
        else {
            return `Неизвестное ТЗ`
        }
    }

    const getComment = (v) => {
        return (
            <div style={{display: "flex", flexDirection: "column"}}>
                {value?.versions?.[v]?.fbs && <Typography style={{fontSize: "12px"}}>FBS</Typography>}
                {value?.versions?.[v]?.comment && value?.versions?.[v]?.comment !== ''?
                    <Typography style={{fontSize: "12px"}}>{value?.versions?.[v]?.comment}</Typography>
                :
                    <Typography style={{fontSize: "12px"}}>Без комментария</Typography>
                }
            </div>
        )
    }

    const getCommentText = (v) => {
        if (value?.versions?.[v]?.comment || value?.versions?.[v]?.fbs) {
            return `${value?.versions?.[v]?.fbs? "FBS": ""}${value?.versions?.[v]?.comment && value?.versions?.[v]?.fbs? " - ": ""}${value?.versions?.[v]?.comment? value?.versions?.[v]?.comment: ""}`
        }
        else {
            return undefined
        }
    }

    const deltz = () => {
        ShowModal(
            'Удаление ТЗ',
            <div>Вы уверены, что хотите удалить ТЗ?</div>,
            async () => {
                await onChange({...id, version, del: true})
                setOpen(false)
            }
        );
    }
    
    console.log("UTTBvalue", value)

    
        
    if (value?.progress !== undefined) {return (
        <div style={{width: '100%', height: '105px', display: 'flex', flexDirection: 'row', justifyContent: 'center', padding: '16px'}} onClick={onClickRow}>
            {/* <LinearProgressWithLabel value={value.progress}/> */}
            <CircularProgressWithLabel value={value.progress} />
        </div>
    )}

    if (value?.blocked !== undefined) {return (
        <div style={{width: '100%', height: '105px', display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
            <Typography variant="subtitle2" >
                {value.blocked}
            </Typography>
        </div>
    )}

    
    
    return (
        <div style={{width:'100%', display: 'flex', flexDirection: 'column'}}>
            
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start'}}>
                <Button
                    onClick={()=>setOpen(true)}
                    variant="text"
                    sx={{width:'100%', height: 64, color: 'black',textTransform: 'none',
                        fontSize: '0.8rem',overflow: 'hidden',padding: '0px',borderRadius: '14px', backgroundColor:'#d6ebec' }}>
                    <Scrollbars
                        style={{height: "100%", width: "100%"}} 
                        autoHide>
                    {value?.versions?.[version]?.text ? 
                        <Typography variant="subtitle2" style={{textAlign: 'left', padding:'8px'}}>
                            {value?.versions?.[version]?.text}
                        </Typography>
                        : <div style={{display: "flex", flexDirection: "column", justifyContent: "center", height: "100%"}}>
                            <Typography variant="subtitle2" >
                                Составить техническое задание
                            </Typography>
                        </div>
                    }
                    </Scrollbars>
                </Button>

            </div>

            <div style={{ 
                display: 'flex', 
                flexDirection: 'row', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                width: '100%',
                marginBottom: '10px'
            }}>
                {loading ? (<Loading />) 
                : 
                    (<>
                        {(() => {
                            const currentServices = value?.versions?.[version]?.services || [];
                            const hasServices = currentServices.length > 0;

                            return (
                                <>
                                    <Tooltip title={hasServices ? "Список услуг" : "Услуги не выбраны!"}>
                                        <IconButton 
                                            size="small" 
                                            onClick={handleOpenServices}
                                            style={{ 
                                                padding: '4px',
                                                border: '1px solid',
                                                borderRadius: '5px',
                                                // color: hasServices ? '#ffffff' : '#424242',
                                                color: '#424242',
                                                // backgroundColor: hasServices ? '#208f84' : '#838383',
                                                maxHeight:'30px',
                                                maxWidth:'30px',
                                                marginLeft:'2%'
                                            }}
                                        >
                                        {openService ? (
                                            <KeyboardArrowUpIcon sx={{ fontSize: 18 }} />) : (<KeyboardArrowDownIcon sx={{ fontSize: 18 }} />
                                        )}
                                        </IconButton>
                                    </Tooltip>

                                    <Popover
                                        open={openService}
                                        anchorEl={anchorEl}
                                        onClose={handleCloseServices}
                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                        PaperProps={{
                                            style: { 
                                                padding: '12px', 
                                                width: '350px', 
                                                marginTop: '5px' ,
                                                borderRadius:'12px',
                                                marginLeft:'-5px'
                                            }
                                        }}
                                    >
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: "row",
                                            flexWrap: "wrap",
                                            width: '100%',
                                            gap: '8px 4px',
                                            justifyContent: 'flex-start',
                                        }}>
                                            {hasServices ? (
                                                currentServices.map((cel) => {
                                                    let idx = services.findIndex((fel) => fel.name === cel.name);
                                                    if (idx > -1) {
                                                        const getTooltipContent = (data) => {
                                                            if (!data) return null;
                                                            let allItems = [];
                                                            if (!data.count) {
                                                                Object.keys(data).forEach((k) => { 
                                                                    allItems = allItems.concat(data[k]); 
                                                                });
                                                            } else {
                                                                allItems.push(data);
                                                            }
                                                            if (allItems.length === 0) return null;

                                                            return (
                                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                                                    {allItems.map((item, i) => (
                                                                        <div key={i} style={{ fontSize: '11px' }}>
                                                                            {item.name 
                                                                                ? `${i + 1}) ${item.name} ${item.size ? `(${item.size})` : ''} - ${item.count} ед.` 
                                                                                : `Количество - ${item.count} на ед.`
                                                                            }
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            );
                                                        };

                                                        const tooltipContent = getTooltipContent(cel.data);

                                                        return (
                                                            <Tooltip 
                                                                title={tooltipContent || "Нет данных"} 
                                                                key={cel.name} 
                                                                arrow 
                                                                placement="top"
                                                            >
                                                                <div style={{
                                                                    display: 'flex', 
                                                                    flexDirection: "row", 
                                                                    alignItems: 'center', 
                                                                    width: '48%', 
                                                                    cursor: 'default'
                                                                }}> 
                                                                    <div style={{
                                                                        minWidth: '8px',
                                                                        height: '8px',
                                                                        backgroundColor: pastelColors[idx % pastelColors.length],
                                                                        marginRight: "6px",
                                                                        borderRadius: '1px' 
                                                                    }} />
                                                                    <Typography style={{ fontSize: "14px", color: '#000000' , fontWeight:'200'}}>
                                                                        {cel.name}
                                                                    </Typography>
                                                                </div>
                                                            </Tooltip>
                                                        );
                                                    }
                                                    return null;
                                                })
                                            ) : (
                                                <Typography style={{ fontSize: '14px', color: '#666', width: '100%', textAlign: 'center' }}>
                                                    Список услуг пуст
                                                </Typography>
                                            )}
                                        </div>
                                    </Popover>
                                </>
                            );
                        })()}
                    </>)
                }
                <div style={{marginLeft: "30px"}}>
                    <VersionSelect
                        value={version}
                        versions={versions}
                        onChange={changeVersion}
                        // getLabel={titleVersion}
                        getLabel={getTitleVersionText}
                        // getTooltip={getComment}
                        getTooltip={getCommentText}
                        width="250px"
                    />
                </div>
                <div style={{display: 'flex', }}>
                    
                    {!onlyVersions &&
                        <IconButton 
                            aria-label="copy" 
                            onClick={() => addVer()} 
                            style={{ marginTop: '0', marginLeft: '5px' }} 
                            sx={{padding: '8px'}}>
                            <AddIcon
                                sx={{
                                    transition: 'all 0.3s ease',
                                    '&:hover': hoverStyle
                                }}
                            />
                        </IconButton>
                    }
                    {!onlyVersions &&
                        <IconButton 
                            aria-label="copy" 
                            onClick={() => copyToOther()} 
                            style={{ marginTop: '0', marginLeft: '5px' }} 
                            sx={{padding: '8px'}}>
                            <ContentCopyIcon
                                sx={{
                                    transition: 'all 0.3s ease',
                                    '&:hover': hoverStyle
                                }}
                            />
                        </IconButton>
                    }
                </div>
            </div>

            <Dialog
                open={open}
                maxWidth='lg'
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setOpen(false)}}
            >
                <div style={{ height: '650px', width: '1180px', padding: '12px', position: 'relative' , overflow:'hidden'}}>
                    <TechSpecif 
                        text={value?.versions?.[version]?.text || ""} 
                        inServices={value?.versions?.[version]?.services || []} 
                        changeText={changeText} 
                        close={closeWindow} 
                        cancel={() => { cancelEdit()}}
                        editable={!onlyVersions} 
                        customPrint={value?.versions?.[version]?.print || "classic" } 
                        comment={value?.versions?.[version]?.comment || ""}
                        fbs={value?.versions?.[version]?.fbs || false}
                        hide={value?.versions?.[version]?.hide || false}
                        canHide={desc?.canHideTZ || false}
                        barcode={value?.barcode}
                        version={version}
                        versionsCount = {value?.versions}
                        vendorCode={value?.vendorCode}
                        title={value?.title}
                        nmID={id?.row?.id}
                        deltz={deltz}
                        inMarket={value?.market}

                    />
                </div>

            </Dialog>
        </div>
        
    );
    
};


const VersionSelect = ({
  value,
  versions,
  onChange,
  getLabel,
  getTooltip,
  width = '150px',
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [menuWidth, setMenuWidth] = useState(width);
  const selectRef = useRef(null);

  useEffect(() => {
    if (isOpen && selectRef.current) {
      // Получаем реальную ширину селекта и вычитаем 2 пикселя, чтобы компенсировать разницу из-за border
      const realWidth = selectRef.current.offsetWidth;
      setMenuWidth(realWidth - 0.5); // подберите значение: 1 или 2
    }
  }, [isOpen]);

  function customSort(arr) {
        // Проверяем наличие 'main'
        const hasMain = arr.includes('main');
        const result = hasMain ? ['main'] : [];
        
        // Регулярное выражение для формата alt_ЧИСЛО
        const altRegex = /^alt_\d+$/;
        const altItems = [];
        const otherItems = [];
        
        for (const item of arr) {
            if (item === 'main') continue; // 'main' уже обработан
            if (altRegex.test(item)) {
                altItems.push(item);
            } else {
                otherItems.push(item);
            }
        }
        
        // Сортируем altItems по числовому значению после подчёркивания
        altItems.sort((a, b) => {
            const numA = parseInt(a.split('_')[1], 10);
            const numB = parseInt(b.split('_')[1], 10);
            return numA - numB;
        });
        
        return [...result, ...altItems, ...otherItems];
    }

  return (
    <div style={{ width, display: 'flex', justifyContent: 'center' }} ref={selectRef}>
        <FormControl fullWidth>
        <Select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            open={isOpen}
            onOpen={() => setIsOpen(true)}
            onClose={() => setIsOpen(false)}
            variant="standard"
            disableUnderline
            sx={{
            '& .MuiSelect-select': {
                transition: 'background-color 0.2s ease',
                borderRadius: isOpen ? '10px 10px 0 0' : '10px',
                padding: '6px 12px',
                backgroundColor: isOpen ? '#ffffff' : 'transparent',
                border: isOpen ? '1px solid #e0e0e0' : 'none',
                borderBottom: isOpen ? 'none' : 'none',
                boxSizing: 'border-box',
                // Для текста внутри select – обрезка с многоточием
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
            },
            '&.Mui-focused .MuiSelect-select': {
                backgroundColor: isOpen ? '#ffffff' : 'transparent',
                borderRadius: isOpen ? '10px 10px 0 0' : '10px',
                border: isOpen ? '1px solid #e0e0e0' : 'none',
                borderBottom: isOpen ? 'none' : 'none',
            },
            '&:hover .MuiSelect-select': {
                backgroundColor: isOpen ? '#ffffff' : '#d6ebec',
                borderRadius: isOpen ? '10px 10px 0 0' : '10px',
                border: isOpen ? '1px solid #e0e0e0' : 'none',
                borderBottom: isOpen ? 'none' : 'none',
            },
            '& .MuiSelect-select.Mui-active': {
                backgroundColor: isOpen ? '#ffffff' : 'transparent',
                borderRadius: isOpen ? '10px 10px 0 0' : '10px',
                border: isOpen ? '1px solid #e0e0e0' : 'none',
                borderBottom: isOpen ? 'none' : 'none',
            },
            '& .MuiSelect-select:active': {
                backgroundColor: isOpen ? '#ffffff' : 'transparent',
                borderRadius: isOpen ? '10px 10px 0 0' : '10px',
                border: isOpen ? '1px solid #e0e0e0' : 'none',
                borderBottom: isOpen ? 'none' : 'none',
            },
            }}
            MenuProps={{
            anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            transformOrigin: { vertical: 'top', horizontal: 'left' },
            PaperProps: {
                style: {
                width: menuWidth,
                minWidth: 'auto',
                },
                sx: {
                backgroundColor: '#ffffff',
                boxShadow: 'none',
                border: '1px solid #e0e0e0',
                borderTop: 'none',
                borderRadius: '0 0 10px 10px',
                marginTop: '0px',
                boxSizing: 'border-box',
                '& .MuiList-root': {
                    padding: 0,
                },
                '& .MuiMenuItem-root': {
                    backgroundColor: 'transparent',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    },
                },
                },
            },
            }}
            renderValue={(selected) => {
            const label = getLabel(selected);
            console.log("label", label)
            const tooltip = getTooltip(selected);
            const displayText = tooltip ? `${label} - ${tooltip}` : label;
            console.log("DT", displayText)
            return (
                <span title={displayText} style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {displayText}
                </span>
            );
            }}
        >
            {customSort(versions).map((v) => {
            const label = getLabel(v);
            const tooltip = getTooltip(v);
            const displayText = tooltip ? `${label} - ${tooltip}` : label;
            return (
                <MenuItem
                key={v}
                value={v}
                sx={{
                    display: 'block',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}
                title={displayText}
                >
                    {displayText}
                </MenuItem>
            );
            })}
        </Select>
        </FormControl>
    </div>
    );
};


// @ts-ignore
function AdminTechTaskButton({ value, desc, id, onChange }) {
    //console.log("UploadTechTaskButton", value)
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [services, setServices] = useState([])
    const [versions, setVersions] = useState(["main"])
    const [version, setVersion] = useState("main")
    const [editMode, setEditMode] = useState(false)
    const [blocked, setBlocked] = useState(false)

    /** @type {[any, Function]} */
    const [preCreateCopy, setPreCreateCopy] = useState(undefined)
    
    let actualText = value?.versions?.[value.TZV || 'main']?.text || ""
    let actualServices = value?.versions?.[value.TZV || 'main']?.services || ""
    let actualPrint = value?.versions?.[value.TZV || 'main']?.print || "classic"
    let actualComment = value?.versions?.[value.TZV || 'main']?.comment || ""
    let actualFBS = value.versions?.[value.TZV || 'main']?.fbs || false
    let actualHide = value.versions?.[value.TZV || 'main']?.hide || false


    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleOpenServices = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseServices = () => {
        setAnchorEl(null);
    };

    const openService = Boolean(anchorEl);

    const closeWindow = ()=>{
        onChange({
            ...id, 
            text: actualText, 
            services: actualServices, 
            print: actualPrint, 
            comment:actualComment, 
            fbs:actualFBS, 
            hide:actualHide, 
            version: version,
            changeTZ: true
        });
        setOpen(false)
    }

    const save = ()=>{
        ShowModal(
                'Применение изменений к сделке',
                <div>Хотите применить изменения к товару непосредственно в этой сделке?</div>,
                async () => {
                    onChange({
                        ...id, 
                        saveTZ: true
                    });
                    setLoading(true)
                }
            );        
    }

    const {company_id } = useSelector(
        loginSelector
    );


    //Не очень хорошо постоянно запрашивать заного, надо подумать, как правильно сделать
    useEffect(() => {
        const fetchData = async () => {
            try{
                setLoading(true)
                const responseData = await get('Handbook/getOnName', {company_id, name: "services"});
                //console.log(responseData)
                if (responseData.message?.[0].data) {
                    let $data = JSON.parse(responseData.message[0].data)
                    //console.log("$data", $data)
                    if ($data.values) {
                        setServices($data.values)
                    }
                }
            }
            catch {}
            finally {setLoading(false)}

        }

        fetchData();
    }, []);

    useEffect(() => {
        console.log("ATTB", value)
        if (value.versions) {
            let tmp = Object.keys(value.versions)
            setVersions(tmp)
            if (tmp.length >0) {setVersion(tmp[0])}
        }
        if (value.services) {
            let noCalc = false
            for (let serv of value.services) {
                if (!serv?.data?.count) {
                    for (let k of Object.keys(serv?.data)) {
                        for (let el of serv.data[k]) {
                            if (el.noCalc) {
                                noCalc = true
                                break
                            }
                        }
                        if (noCalc) {break}
                    }
                }
                if (noCalc) {break}
            }
            setBlocked(noCalc)
        }
        if (value.TZV) {
            setVersion(value.TZV)
        }
        if (value.editMode) {
            setEditMode(true)
            setLoading(false)
        }
        if (value.editModeClose) {
            setEditMode(false)
            setLoading(false)
        }
    }, [value]);

    // @ts-ignore
    const changeText = (text, services, print, sv, comment, fbs, hide = false)=>{
        actualText = text
        actualServices = services
        actualPrint = print
        actualComment = comment
        actualFBS = fbs
        actualHide = hide
    }

    const changeVersion = (v) => {
        setVersion(v)
        onChange({...id, swap:v, changeTZ: true});
        actualText = value?.versions?.[v]?.text || ""
        actualServices = value?.versions?.[v]?.services || ""
        actualPrint = value?.versions?.[v]?.print || "classic"
        actualComment = value?.versions?.[v]?.comment || ""
        actualFBS = value?.versions?.[v]?.fbs || false
        actualHide = value?.versions?.[v]?.hide || false
    }

    const addVer = () => {

        //Создаем копию на всякий
        let old = JSON.parse(JSON.stringify({
            actualText,
            actualServices,
            actualPrint,
            actualComment,
            actualFBS,
            version,
            versions
        }))
        setPreCreateCopy(old)

        actualText = ""
        actualServices = ""
        actualPrint = "classic"
        actualComment = ""
        actualFBS = false
        
        let name = getNextItem(Object.keys(value.versions))

        onChange({...id, swap:name, changeTZ: true});
        setVersion(name)
        setVersions([...versions, name])
        setOpen(true)
    }    

    const cancelEdit = () => {
        if (preCreateCopy) {
            actualText = preCreateCopy.actualText
            actualServices = preCreateCopy.actualServices
            actualPrint = preCreateCopy.actualPrint
            actualComment = preCreateCopy.actualComment
            actualFBS = preCreateCopy.actualFBS

            onChange({...id, swap:preCreateCopy.version});
            setVersion(preCreateCopy.version)
            setVersions(preCreateCopy.versions)
        }
        setPreCreateCopy(undefined)
        setOpen(false)
    }

    const titleVersion = (v) => {
        if (v) {
            let text = v === 'main'? `ТЗ 1`: v === 'defect'? "Брак": v.split('_')[0] === 'alt'? `ТЗ ${v.split('_')[1]}`: `Неизвестное ТЗ`
            if (value.fbs) {text += " - FBS"}
            return (
                <Typography variant="subtitle2" >
                    {text}
                </Typography>
            )
        }
        else {
            return (
                <Typography variant="subtitle2" >
                    {`Неизвестное ТЗ`}
                </Typography>
            )
        }
    }

    const getTitleVersionText = (v) => {
        if (v) {
            return v === 'main'? `ТЗ 1`: v === 'defect'? "Брак": v.split('_')[0] === 'alt'? `ТЗ ${v.split('_')[1]}`: `Неизвестное ТЗ`
        }        
        else {
            return `Неизвестное ТЗ`
        }
    }

    const getComment = (v) => {
        return (
            <div style={{display: "flex", flexDirection: "column"}}>
                {value?.versions?.[v]?.fbs && <Typography style={{fontSize: "12px"}}>FBS</Typography>}
                {value?.versions?.[v]?.comment && value?.versions?.[v]?.comment !== ''?
                    <Typography style={{fontSize: "12px"}}>{value?.versions?.[v]?.comment}</Typography>
                :
                    <Typography style={{fontSize: "12px"}}>Без комментария</Typography>
                }
            </div>
        )
    }

    const getCommentText = (v) => {
        if (value?.versions?.[v]?.comment || value?.versions?.[v]?.fbs) {
            return `${value?.versions?.[v]?.fbs? "FBS": ""}${value?.versions?.[v]?.comment && value?.versions?.[v]?.fbs? " - ": ""}${value?.versions?.[v]?.comment? value?.versions?.[v]?.comment: ""}`
        }
        else {
            if (value?.comment || value?.fbs) {
                return `${value?.fbs? "FBS": ""}${value?.comment && value?.fbs? " - ": ""}${value?.comment? value?.comment: ""}`
            }
            return undefined
        }
    }


    const changeMode = () => {
        ShowModal(
            'Режим редактирования ТЗ',
            <div>В это режиме вы сможете редактировать все ТЗ для товара от лица клиента. Хотите перейти в этот режим?</div>,
            async () => {
                setLoading(true)
                onChange({...id, changeTZMode: true})     
            }
        ); 
    }
    

    if (!editMode) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                
                <Button
                    onClick={() => setOpen(true)}
                    variant="text"
                    sx={{
                        width: '100%',
                        height: 64,
                        color: 'black',
                        textTransform: 'none',
                        fontSize: '0.8rem',
                        overflow: 'hidden',
                        borderRadius: '14px', 
                        backgroundColor:'#d6ebec',
                        padding: '8px'
                    }}
                >
                    <Scrollbars style={{ height: "100%", width: "100%" }} autoHide>
                        {value?.text ? (
                            <Typography variant="subtitle2" style={{ textAlign: 'left' }}>
                                {value?.text}
                            </Typography>
                        ) : (
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", height: "100%" }}>
                                <Typography variant="subtitle2">
                                    Техническое задание отсутствует
                                </Typography>
                            </div>
                        )}
                    </Scrollbars>
                </Button>

                <div style={{ 
                    display: 'flex', 
                    flexDirection: 'row', 
                    alignItems: 'center', 
                    width: '100%',
                    marginBottom: '10px'
                }}>

                    {loading ? (
                        <Loading />
                    ) : (
                        <div style={{ 
                            display: 'flex', 
                            flexDirection: 'row', 
                            alignItems: 'center', 
                            justifyContent: "space-between",
                            // width: '100%', 
                            width: '380px',
                            marginTop: '8px' 
                        }}>
                            {(() => {
                                const currentServices = value?.services || [];
                                const hasServices = currentServices.length > 0;

                                return (
                                    <>
                                        <Tooltip title={hasServices ? "Список услуг ТЗ" : "Услуги в ТЗ не указаны!"}>
                                            <IconButton 
                                                size="small" 
                                                onClick={handleOpenServices}
                                                style={{ 
                                                padding: '4px',
                                                    border: '1px solid',
                                                    borderRadius: '5px',
                                                    // color: hasServices ? '#ffffff' : '#424242',
                                                    color: '#424242',
                                                    // backgroundColor: hasServices ? '#208f84' : '#838383',
                                                    maxHeight:'30px',
                                                    maxWidth:'30px',
                                                    marginLeft:'2%'
                                                }}
                                            >
                                                {openService ? (
                                                    <KeyboardArrowUpIcon sx={{ fontSize: 18 }} />) : (<KeyboardArrowDownIcon sx={{ fontSize: 18 }} />
                                                )}
                                            </IconButton>
                                        </Tooltip>

                                        <Popover
                                            open={openService}
                                            anchorEl={anchorEl}
                                            onClose={handleCloseServices}
                                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                            PaperProps={{
                                                style: { 
                                                    padding: '12px', 
                                                    width: '380px', 
                                                    marginTop: '5px' ,
                                                    borderRadius:'12px',
                                                    marginLeft:'-5px'
                                                }
                                            }}
                                        >
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: "row",
                                                flexWrap: "wrap",
                                                width: '100%',
                                                gap: '8px 4px',
                                                justifyContent: 'flex-start'
                                            }}>
                                                {hasServices ? (
                                                    currentServices.map((cel) => {
                                                        let idx = services.findIndex((fel) => fel.name === cel.name);
                                                        if (idx > -1) {
                                                            const getTooltipContent = (data) => {
                                                                if (!data) return null;
                                                                let allItems = [];
                                                                if (!data.count) {
                                                                    Object.keys(data).forEach((k) => { allItems = allItems.concat(data[k]) });
                                                                } else {
                                                                    allItems.push(data);
                                                                }
                                                                return (
                                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                                                        {allItems.map((item, i) => (
                                                                            <div key={i} style={{ fontSize: '11px' }}>
                                                                                {item.name 
                                                                                    ? `${i + 1}) ${item.name} ${item.size ? `(${item.size})` : ''} - ${item.count} ед.` 
                                                                                    : `Кол-во: ${item.count}`}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                );
                                                            };

                                                            return (
                                                                <Tooltip 
                                                                    title={getTooltipContent(cel.data) || "Нет данных"} 
                                                                    key={cel.name} 
                                                                    arrow 
                                                                    placement="top"
                                                                    >
                                                                    <div style={{
                                                                        display: 'flex', 
                                                                        flexDirection: "row", 
                                                                        alignItems: 'center', 
                                                                        width: '48%', 
                                                                        cursor: 'default'
                                                                    }}> 
                                                                        <div style={{
                                                                            minWidth: '8px',
                                                                            height: '8px',
                                                                            backgroundColor: pastelColors[idx % pastelColors.length],
                                                                            marginRight: "6px",
                                                                            borderRadius: '1px' 
                                                                        }} />
                                                                        <Typography style={{ fontSize: "14px", color: '#000000' , fontWeight:'200'}}>
                                                                            {cel.name}
                                                                        </Typography>
                                                                    </div>
                                                                </Tooltip>
                                                            );
                                                        }
                                                        return null;
                                                    })
                                                ) : (
                                                    <Typography style={{ fontSize: '14px', color: '#666', width: '100%', textAlign: 'center' }}>
                                                        Список услуг пуст
                                                    </Typography>
                                                )}
                                            </div>
                                        </Popover>
                                    </>
                                );
                            })()}

                            <div style={{marginRight: "10px",width: "70px", display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
                                {titleVersion(value.version)}
                            </div>
                            <IconButton 
                                aria-label="copy" 
                                onClick={() => changeMode()} 
                                style={{ marginTop: '0', marginLeft: '5px' }} 
                                disabled={blocked}
                                sx={{padding: '8px'}}>
                                <EditNoteIcon
                                    sx={{
                                        transition: 'all 0.3s ease',
                                        '&:hover': hoverStyle
                                    }}
                                />
                            </IconButton>
                        </div>
                    )}
                </div>

                <Dialog
                    open={open}
                    maxWidth='lg'
                    PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                    onClose={() => { setOpen(false) }}
                >
                    <div style={{ height: '650px', width: '1180px', padding: '12px' }}>
                        <TechSpecif 
                            text={value?.text} 
                            inServices={value?.services} 
                            changeText={() => {}} 
                            close={() => { cancelEdit()}} 
                            cancel={() => { cancelEdit()}}
                            editable={false} 
                            customPrint={undefined}
                            title={value?.title}
                            vendorCode={value?.vendorCode}
                            barcode={value?.barcode}
                            inMarket={value?.market}
                        />
                    </div>
                </Dialog>
            </div>
        );
    }
    
    return (
        <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
            <Button
                onClick={()=>setOpen(true)}
                variant="text"
                sx={{width:'100%', height: 64, color: 'black',textTransform: 'none',
                    fontSize: '0.8rem',overflow: 'hidden',padding: '0px',borderRadius: '14px', backgroundColor:'#d6ebec' }}>
                <Scrollbars
                    style={{height: "100%", width: "100%"}} 
                    autoHide>
                {value?.versions?.[version]?.text ? 
                    <Typography variant="subtitle2" style={{textAlign: 'left', padding:'8px'}}>
                        {value?.versions?.[version]?.text}
                    </Typography>
                    : <div style={{display: "flex", flexDirection: "column", justifyContent: "center", height: "100%"}}>
                        <Typography variant="subtitle2" >
                            Составить техническое задание
                        </Typography>
                    </div>
                }
                </Scrollbars>
            </Button>

            <div style={{ 
                    display: 'flex', 
                    flexDirection: 'row', 
                    alignItems: 'center', 
                    width: '100%',
                    marginBottom: '10px',
                    justifyContent: 'space-between'
                    }}>
                {loading ? (
                    <Loading />
                ) : (
                    <>
                        {(() => {
                            const currentServices = value?.versions?.[version]?.services || [];
                            const hasServices = currentServices.length > 0;

                            return (
                                <>
                                    <Tooltip title={hasServices ? "Список услуг" : "Услуги не выбраны!"}>
                                        <IconButton 
                                            size="small" 
                                            onClick={handleOpenServices}
                                            style={{ 
                                                padding: '4px',
                                                border: '1px solid',
                                                borderRadius: '5px',
                                                // color: hasServices ? '#ffffff' : '#424242',
                                                color: '#424242',
                                                // backgroundColor: hasServices ? '#208f84' : '#838383',
                                                maxHeight:'30px',
                                                maxWidth:'30px',
                                                marginLeft:'2%'
                                            }}
                                        >
                                        {openService ? (
                                            <KeyboardArrowUpIcon sx={{ fontSize: 18 }} />) : (<KeyboardArrowDownIcon sx={{ fontSize: 18 }} />
                                        )}
                                        </IconButton>
                                    </Tooltip>

                                    <Popover
                                        open={openService}
                                        anchorEl={anchorEl}
                                        onClose={handleCloseServices}
                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                        PaperProps={{
                                            style: { 
                                                padding: '12px', 
                                                width: '100%', 
                                                marginTop: '5px' ,
                                                borderRadius:'12px',
                                                marginLeft:'-5px'
                                            }
                                        }}
                                    >
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: "row",
                                            flexWrap: "wrap",
                                            width: '100%',
                                            gap: '8px 4px',
                                            justifyContent: 'flex-start',
                                        }}>
                                            {hasServices ? (
                                                currentServices.map((cel) => {
                                                    let idx = services.findIndex((fel) => fel.name === cel.name);
                                                    if (idx > -1) {
                                                        const getTooltipContent = (data) => {
                                                            if (!data) return null;
                                                            let allItems = [];
                                                            if (!data.count) {
                                                                Object.keys(data).forEach((k) => { 
                                                                    allItems = allItems.concat(data[k]); 
                                                                });
                                                            } else {
                                                                allItems.push(data);
                                                            }
                                                            if (allItems.length === 0) return null;

                                                            return (
                                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                                                    {allItems.map((item, i) => (
                                                                        <div key={i} style={{ fontSize: '11px' }}>
                                                                            {item.name 
                                                                                ? `${i + 1}) ${item.name} ${item.size ? `(${item.size})` : ''} - ${item.count} ед.` 
                                                                                : `Количество - ${item.count} на ед.`
                                                                            }
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            );
                                                        };

                                                        const tooltipContent = getTooltipContent(cel.data);

                                                        return (
                                                            <Tooltip 
                                                                title={tooltipContent || "Нет данных"} 
                                                                key={cel.name} 
                                                                arrow 
                                                                placement="top"
                                                            >
                                                                <div style={{
                                                                    display: 'flex', 
                                                                    flexDirection: "row", 
                                                                    alignItems: 'center', 
                                                                    width: '48%', 
                                                                    cursor: 'default'
                                                                }}> 
                                                                    <div style={{
                                                                        minWidth: '8px',
                                                                        height: '8px',
                                                                        backgroundColor: pastelColors[idx % pastelColors.length],
                                                                        marginRight: "6px",
                                                                        borderRadius: '1px' 
                                                                    }} />
                                                                    <Typography style={{ fontSize: "14px", color: '#000000' , fontWeight:'200'}}>
                                                                        {cel.name}
                                                                    </Typography>
                                                                </div>
                                                            </Tooltip>
                                                        );
                                                    }
                                                    return null;
                                                })
                                            ) : (
                                                <Typography style={{ fontSize: '14px', color: '#666', width: '100%', textAlign: 'center' }}>
                                                    Список услуг пуст
                                                </Typography>
                                            )}
                                        </div>
                                    </Popover>
                                </>
                            );
                        })()}
                    </>
                )}
                {/* версия */}
                <div style={{flex: 1,
                        display: 'flex', 
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginLeft:'60px'}}>

                    <VersionSelect
                        value={version}
                        versions={versions}
                        onChange={changeVersion}
                        // getLabel={titleVersion}
                        getLabel={getTitleVersionText}
                        // getTooltip={getComment}
                        getTooltip={getCommentText}
                        width="250px"
                    />
                </div>
                <div style={{
                    display: 'flex', 
                    marginLeft:'30px'}}>

                    <IconButton 
                        aria-label="copy" 
                        onClick={() => addVer()} 
                        style={{ marginTop: '0', marginLeft: '5px' }} 
                        sx={{padding: '8px'}}>
                        <AddIcon
                            sx={{
                                transition: 'all 0.3s ease',
                                '&:hover': hoverStyle
                            }}
                        />
                    </IconButton>
                    <IconButton 
                        aria-label="copy" 
                        onClick={() => save()} 
                        style={{ marginTop: '0', marginLeft: '5px' }} 
                        sx={{padding: '8px'}}>
                        <SaveIcon
                            sx={{
                                transition: 'all 0.3s ease',
                                '&:hover': hoverStyle
                            }}
                        />
                    </IconButton>
                </div>
            </div>

            <Dialog
                open={open}
                maxWidth='lg'
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setOpen(false)}}
            >
                <div style={{ height: '650px', width: '1180px', padding: '12px', position: 'relative' , overflow:'hidden'}}>
                    <TechSpecif 
                        text={value?.versions?.[version]?.text || ""} 
                        inServices={value?.versions?.[version]?.services || []} 
                        changeText={changeText} 
                        close={closeWindow} 
                        cancel={() => { cancelEdit()}}
                        editable={true} 
                        customPrint={value?.versions?.[version]?.print || "classic" } 
                        comment={value?.versions?.[version]?.comment || ""}
                        fbs={value?.versions?.[version]?.fbs || false}
                        hide={value?.versions?.[version]?.hide || false}
                        barcode={value?.barcode}
                        version={version}
                        versionsCount = {value?.versions}
                        vendorCode={value?.vendorCode}
                        title={value?.title}
                        nmID={value?.nmID}
                        deal_id={value?.deal_id}
                        cli_id={value.cli_id}
                        inMarket={value?.market}
                    />
                </div>

            </Dialog>
        </div>
        
    );
    
};

// кнопка для технического задания без возмодности редактирования
// Компонент для отображения технического задания без возможности редактирования
// @ts-ignore
function ShowTechTaskButton({ value, desc, id }) {
    console.log("ShowTechTaskButton", value)
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [services, setServices] = useState([]);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleOpenServices = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseServices = () => {
        setAnchorEl(null);
    };

    const openService = Boolean(anchorEl);

    const closeWindow = () => {
        setOpen(false);
    };

    //console.log("ShowTechTaskButton", value)

    const { company_id } = useSelector(loginSelector);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const responseData = await get('Handbook/getOnName', { company_id, name: "services" });
                if (responseData.message?.[0].data) {
                    let $data = JSON.parse(responseData.message[0].data);
                    if ($data.values) {
                        setServices($data.values);
                    }
                }
            } catch (err) {
                console.error("Error fetching services:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [company_id]);

    const titleVersion = (v) => {
        if (v) {
            return (
                <Typography variant="subtitle2" >
                    {v === 'main'? `ТЗ 1`: v === 'defect'? "Брак": v.split('_')[0] === 'alt'? `ТЗ ${v.split('_')[1]}`: `Неизвестное ТЗ`}
                </Typography>
            )
        }
        else {
            return (
                <Typography variant="subtitle2" >
                    {`Неизвестное ТЗ`}
                </Typography>
            )
        }
    }

    const getTitleVersionText = (v) => {
        if (v) {
            return v === 'main'? `ТЗ 1`: v === 'defect'? "Брак": v.split('_')[0] === 'alt'? `ТЗ ${v.split('_')[1]}`: `Неизвестное ТЗ`
        }        
        else {
            return `Неизвестное ТЗ`
        }
    }

    const label = getTitleVersionText(value.version);
    console.log("AAAAAAAAAAAAAAAAAA", value)
    const displayText = `${label}${value.fbs? ' - FBS': ''}${value.comment? ' - '+value.comment: ''}`//value.comment ? `${label} - ${value.comment}` : label;

    if (value === -1) return null;

    return (
        <div style={{ display: 'flex', flexDirection: 'column', width: '400px' }}>
            
            <Button
                onClick={() => setOpen(true)}
                variant="text"
                sx={{
                    width: '380px',
                    height: 64,
                    color: 'black',
                    textTransform: 'none',
                    fontSize: '0.8rem',
                    overflow: 'hidden',
                    borderRadius: '14px', 
                    backgroundColor:'#d6ebec',
                    padding: '8px'
                }}
            >
                <Scrollbars style={{ height: "100%", width: "100%" }} autoHide>
                    {value?.text ? (
                        <Typography variant="subtitle2" style={{ textAlign: 'left' }}>
                            {value?.text}
                        </Typography>
                    ) : (
                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", height: "100%" }}>
                            <Typography variant="subtitle2">
                                Техническое задание отсутствует
                            </Typography>
                        </div>
                    )}
                </Scrollbars>
            </Button>

            <div style={{ 
                display: 'flex', 
                flexDirection: 'row', 
                alignItems: 'center', 
                width: '100%',
                marginBottom: '10px'
            }}>

                {loading ? (
                    <Loading />
                ) : (
                    <div style={{ 
                        display: 'flex', 
                        flexDirection: 'row', 
                        alignItems: 'center', 
                        justifyContent: "space-between",
                        // width: '100%', 
                        width: '380px',
                        marginTop: '8px' 
                    }}>
                        {(() => {
                            const currentServices = value?.services || [];
                            const hasServices = currentServices.length > 0;

                            return (
                                <>
                                    <Tooltip title={hasServices ? "Список услуг ТЗ" : "Услуги в ТЗ не указаны!"}>
                                        <IconButton 
                                            size="small" 
                                            onClick={handleOpenServices}
                                            style={{ 
                                               padding: '4px',
                                                border: '1px solid',
                                                borderRadius: '5px',
                                                // color: hasServices ? '#ffffff' : '#424242',
                                                color: '#424242',
                                                // backgroundColor: hasServices ? '#208f84' : '#838383',
                                                maxHeight:'30px',
                                                maxWidth:'30px',
                                                marginLeft:'2%'
                                            }}
                                        >
                                            {openService ? (
                                                <KeyboardArrowUpIcon sx={{ fontSize: 18 }} />) : (<KeyboardArrowDownIcon sx={{ fontSize: 18 }} />
                                            )}
                                        </IconButton>
                                    </Tooltip>

                                    <Popover
                                        open={openService}
                                        anchorEl={anchorEl}
                                        onClose={handleCloseServices}
                                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                        PaperProps={{
                                            style: { 
                                                padding: '12px', 
                                                width: '380px', 
                                                marginTop: '5px' ,
                                                borderRadius:'12px',
                                                marginLeft:'-5px'
                                            }
                                        }}
                                    >
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: "row",
                                            flexWrap: "wrap",
                                            width: '100%',
                                            gap: '8px 4px',
                                            justifyContent: 'flex-start'
                                        }}>
                                            {hasServices ? (
                                                currentServices.map((cel) => {
                                                    let idx = services.findIndex((fel) => fel.name === cel.name);
                                                    if (idx > -1) {
                                                        const getTooltipContent = (data) => {
                                                            if (!data) return null;
                                                            let allItems = [];
                                                            if (!data.count) {
                                                                Object.keys(data).forEach((k) => { allItems = allItems.concat(data[k]) });
                                                            } else {
                                                                allItems.push(data);
                                                            }
                                                            return (
                                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                                                    {allItems.map((item, i) => (
                                                                        <div key={i} style={{ fontSize: '11px' }}>
                                                                            {item.name 
                                                                                ? `${i + 1}) ${item.name} ${item.size ? `(${item.size})` : ''} - ${item.count} ед.` 
                                                                                : `Кол-во: ${item.count}`}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            );
                                                        };

                                                        return (
                                                            <Tooltip 
                                                                title={getTooltipContent(cel.data) || "Нет данных"} 
                                                                key={cel.name} 
                                                                arrow 
                                                                placement="top"
                                                                >
                                                                <div style={{
                                                                    display: 'flex', 
                                                                    flexDirection: "row", 
                                                                    alignItems: 'center', 
                                                                    width: '48%', 
                                                                    cursor: 'default'
                                                                }}> 
                                                                    <div style={{
                                                                        minWidth: '8px',
                                                                        height: '8px',
                                                                        backgroundColor: pastelColors[idx % pastelColors.length],
                                                                        marginRight: "6px",
                                                                        borderRadius: '1px' 
                                                                    }} />
                                                                    <Typography style={{ fontSize: "14px", color: '#000000' , fontWeight:'200'}}>
                                                                        {cel.name}
                                                                    </Typography>
                                                                </div>
                                                            </Tooltip>
                                                        );
                                                    }
                                                    return null;
                                                })
                                            ) : (
                                                <Typography style={{ fontSize: '14px', color: '#666', width: '100%', textAlign: 'center' }}>
                                                    Список услуг пуст
                                                </Typography>
                                            )}
                                        </div>
                                    </Popover>
                                </>
                            );
                        })()}

                        <div style={{marginRight: "10px",width: "90%", display: "flex", flexDirection: "row", justifyContent: "flex-end", alignItems: 'flex-end'}}>
                            {/* {titleVersion(value.version)} */}
                            {displayText}
                        </div>
                    </div>
                )}
            </div>

            <Dialog
                open={open}
                maxWidth='lg'
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setOpen(false) }}
            >
                <div style={{ height: '650px', width: '1180px', padding: '12px' }}>
                    <TechSpecif 
                        text={value?.text} 
                        inServices={value?.services} 
                        changeText={() => {}} 
                        close={closeWindow} 
                        cancel={() => { setOpen(false)}}
                        editable={false} 
                        customPrint={undefined}
                        title={value?.title}
                        vendorCode={value?.vendorCode}
                        barcode={value?.barcode}
                        inMarket={value?.market}
                    />
                </div>
            </Dialog>
        </div>
    );
}

function ShowTechTaskVersion({ value, desc }) {

    const { user_id } = useSelector(loginSelector);
    const { market } = useSelector(MarketClientSelector);

    const [loading, setLoading] = useState(true);

    const [version, setVersion] = useState("");
    const [comment, setComment] = useState("");
    const [fbs, setFBS] = useState("");

    console.log('SHOW TZ', value);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);

                const responseData = await get('techTask/ClientTechTask', {
                    bar: value.barcode,
                    cid: user_id,
                    market: market
                });


                //Если версия есть
                if (value.techTask.version) {
                    const TZ = responseData?.versions?.[value.techTask.version]
                    console.log("TZ", TZ)
                    setVersion(value.techTask.version);
                    setComment(TZ.comment);
                    setFBS(TZ.fbs);

                }

            } catch (err) {
                console.error("Error fetching services:", err);
            } finally {
                setLoading(false);
            }
        };

        if (value) {
            fetchData();
        }
    }, [user_id, market, value]); // лучше добавить зависимости


    const getTitle = () => {
        if (version === "main") return "ТЗ 1";
        if (version === "defect") return "Брак";
        if (version?.startsWith("alt_")) {
            return `ТЗ ${version.split("_")[1]}`;
        }
        return "Неизвестное ТЗ";
    };

    const displayText = `${getTitle()}${fbs? ' - FBS': ''}${comment ? ' - ' + getTitle(): ""}`
    
    if (loading) {
        return (<Loading />);
    }

    return (
        <div style={{borderRadius: "10px", backgroundColor: '#d6ebec', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', padding: "5px", maxWidth: "200px"}}>
            <Typography variant="subtitle2">
                {displayText}
            </Typography>
        </div>
    )


}


function UserShort({value}) {

    return (
        <div style={{display: "flex", flexDirection: 'row', alignItems: 'center'}}>
            <UserAvatar src={value.photo} userData={{fio:value.fio}} user_id={value.user_id} size={25} />
            <Typography style={{ fontSize: "12px", marginRight: "5px"}}>
                #{value.user_id}
            </Typography>
            <Typography style={{ fontSize: "12px", marginRight: "5px"}}>
                {value.fio}
            </Typography>
        </div>
    )
}

// Форматирование цены в рублях
function formatPrice(str) {
  const value = parseFloat(str.replace(',', '.'));
  if (isNaN(value)) return '–';

  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    minimumFractionDigits: 0,
  }).format(value);
}

// форматерование цены
export function Price({ value }) {
  if (typeof value !== 'string') return <span>–</span>;

  return <span>{formatPrice(value)}</span>;
}

// Форматирование даты в формате ДД.ММ.ГГГГ
function formatDate(isoString) {
  const date = new Date(isoString);
  if (!date) return '–';

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Месяцы с 0
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
}

// форматер даты
export function FormattedDate({ value }) {
  if (typeof value !== 'string') return <span>–</span>;

  return <span>{formatDate(value)}</span>;
}


//сделать кросиво некросиво не делать
function TableColumnFormat({value}) {
    //console.log('VALUE', value)
    if (value){
     return (
        <div 
            style={{ 
                width: '100%',
                flexShrink: 1, 
                display: 'flex', 
                justifyContent: 'center',
                alignItems: 'center',
                whiteSpace: 'normal',
                padding: 0
            }}
        >
            {value}
        </div>
    );
    } else {
        return <NoData />;
    }
    
}

function ShowList({value}) {
    if (value && value.length>0){
     return (
        <div 
            style={{ 
                display: 'flex', 
                flexDirection: "column",
                alignItems: 'center',
            }}
        >
            {value.map((el) => {
                return (
                    <Typography 
                        sx={{ 
                            fontSize: '8pt',
                            backgroundColor: 'rgba(128, 128, 128, 0.2)', // серый полупрозрачный
                            borderRadius: '10px', // закругленные углы
                            padding: '6px 10px', // внутренние отступы
                            margin: "3px",
                            display: 'inline-block' // чтобы прямоугольник был по размеру текста
                        }}
                    >
                        {el}
                    </Typography>
                )
            })}
        </div>
    );
    } else {
        return <></>;
    }
    
}

function BigDisignNumber({value}) {
    if (value){
     return (
        <Typography 
            sx={{ 
                marginLeft: '22%',
                fontSize: '20pt',
            }}
        >
            {value}
        </Typography>
     )
    } else {
        return <></>;
    }
    
}

function MultiWayDelivery({value}) {

    const [color, setColor] = useState("black")

    useEffect(() => {
        if (value) {
            let tmp = value.split('/').map((el) => parseInt(el))
            console.log("TEEST", tmp)
            if (tmp[0] === tmp[1]) {setColor('green')}
            if (tmp[0] > tmp[1]) {setColor('#cd5700')}
            if (tmp[0] < tmp[1]) {setColor('gray')}
        }
    }, [value]);

    if (value){
     return (
        <Typography 
            sx={{ 
                color: color,
                fontWeight: 'bold'
            }}
        >
            {value}
        </Typography>
     )
    } else {
        return <></>;
    }
    
}

function RCK({value}) {

    if (value){
     return (
        <Typography 
            sx={{ 
                fontSize: "12pt",
            }}
        >
            В 1 упаковке {value.kof} {value.title} 
        </Typography>
     )
    } else {
        return <></>;
    }
}

function StorageCount({value}) {

    if (value){
     return (
        <Typography 
            sx={{ 
                fontSize: "12pt",
            }}
        >
            {value >=0? Math.round(value): Math.floor(value)}
        </Typography>
     )
    } else {
        return <></>;
    }
}

function FBSDateWB({ value }) {
    if (!value) return null;

    const date = new Date(value);

    // Проверка на валидность
    if (isNaN(date.getTime())) return null;

    // Форматируем дату по Москве
    const parts = new Intl.DateTimeFormat('ru-RU', {
        timeZone: 'Europe/Moscow',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }).formatToParts(date);

    const getPart = (type) =>
        parts.find((part) => part.type === type)?.value;

    const month = getPart('month');
    const day = getPart('day');
    const hours = getPart('hour');
    const minutes = getPart('minute');
    const year = getPart('year');

    // Форматированная дата для отображения
    const formattedDate = `${day}.${month} (${hours}:${minutes})`;

    // Точная дата и время для подсказки
    const fullDateTime = `${day}.${month}.${year} ${hours}:${minutes} по МСК`;

    // Вычисляем разницу во времени
    const diffMs = Date.now() - date.getTime();
    const diffHours = diffMs / (1000 * 60 * 60);
    const diffMinutes = diffMs / (1000 * 60);

    // Получаем часы и минуты
    const hoursPassed = Math.floor(diffMinutes / 60);
    const minutesPassed = Math.floor(diffMinutes % 60);

    // Формируем строку с прошедшим временем
    let timePassedString = '';
    if (hoursPassed === 0) {
        timePassedString = `${minutesPassed} мин.`;
    } else if (minutesPassed === 0) {
        timePassedString = `${hoursPassed} ч.`;
    } else {
        timePassedString = `${hoursPassed} ч. ${minutesPassed} мин.`;
    }

    // Определяем цвет
    let color;

    if (diffHours < 13) {
        color = successTextColor
    } else if (diffHours > 18 && diffHours <= 24) {
        color = warningTextColor
    } else {
        color = errorTextColor
    }

    return (
        <Tooltip 
            title={
                <div>
                    <div>Создан: {fullDateTime}</div>
                </div>
            }
        >
            <Typography
                sx={{
                    fontSize: '12pt',
                    color,
                    fontWeight: 'bold'
                }}
            >
                {timePassedString}
            </Typography>
        </Tooltip>
    );
}


function FbsStatus({ value }) {

    const [isOpen, setIsOpen] = useState(false);

    const STATUS_LABELS = {
        waiting: { text: 'в работе', color: warningTextColor },
        sorted: { text: 'отсортирован', color: successTextColor },
        sold: { text: 'получен покупателем', color: successTextColor },
        canceled: { text: 'отменен', color: 'gray' },
        canceled_by_client: { text: 'отменен', color: 'gray' },
        declined_by_client: { text: 'отменен', color: 'gray' },
        defect: { text: 'отменен', color: 'gray' },
        ready_for_pickup: { text: 'на ПВЗ', color: successTextColor },
        accepted_by_carrier: { text: 'в службе доставки', color: successTextColor },
        sent_to_carrier: { text: 'в службе доставки', color: successTextColor },
        canceled_by_carrier: { text: 'отменен', color: 'gray' },
    };

    const POSITIVE_STATUSES = new Set(['sold', 'sorted', 'ready_for_pickup', 'accepted_by_carrier', 'sent_to_carrier']);

    if (!value || value.length === 0) return null;

    const positiveCount = value.filter(
        (item) => POSITIVE_STATUSES.has(item.status)
    ).length;

    return (
        <div>
            <div
                onClick={() => setIsOpen((prev) => !prev)}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    cursor: 'pointer',
                    userSelect: 'none',
                }}
            >
                <Typography sx={{ fontSize: '11pt', whiteSpace: 'nowrap', color: positiveCount === value.length? successTextColor: warningTextColor}}>
                    В доставке {positiveCount} из {value.length}
                </Typography>
                <span
                    style={{
                        display: 'inline-block',
                        transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                        transition: 'transform 0.15s ease',
                    }}
                >
                    ▾
                </span>
            </div>

            {isOpen && (
                <div style={{ marginTop: 8 }}>
                    {value.map((item) => {
                        let status = STATUS_LABELS[item.status]
                        return (
                            <div
                                key={item.order}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    gap: 12,
                                }}
                            >
                                <Typography sx={{ fontSize: '11pt', whiteSpace: 'nowrap' }}>
                                    {item.order}
                                </Typography>
                                <Typography sx={{ fontSize: '11pt', whiteSpace: 'nowrap', color: status?.color || 'gray' }}>
                                    {status?.text}
                                </Typography>
                            </div>
                        )
                    })}
                </div>
            )}
        </div>
    );
}

function FBSDealStatus({ value }) {

    

    return (
        <Typography sx={{ fontSize: '11pt', whiteSpace: 'nowrap', color: value === 'waiting' || value === 'old_deal'? warningTextColor: value === 'ok'? successTextColor: errorTextColor}}>
            { value === 'waiting'? "В работе": value === 'ok'? "В доставке": value === "old_deal"? "Не проверялся": "Ошибка"}
        </Typography>
    );
}

// Форматтеры, Необходимы для отображения информации, требующей особого представления
// чаще используются в report table. для этого в дескрипторе указывается  formatter: ключ форматера
// value - значение, которое нужно отобразить
// desc - дескриптор 
// id - идентификатор бд
// onChange - функция, которая вызывается при изменении значения
export const componentFormatters = {
    UploadTechTaskButton: ({ value, desc, id, onChange, onClickRow}) => <UploadTechTaskButton value={value} desc={desc} id={id} onChange={onChange} onClickRow={onClickRow}></UploadTechTaskButton>,
    UploadTechTaskButtonOnlyVersons: ({ value, desc, id, onChange }) => <UploadTechTaskButton value={value} desc={desc} id={id} onChange={onChange} onlyVersions={true}></UploadTechTaskButton>,
    AdminTechTaskButton: ({ value, desc, id, onChange }) => <AdminTechTaskButton value={value} desc={desc} id={id} onChange={onChange}></AdminTechTaskButton>,
    // @ts-ignore
    ShowTechTaskButton: ({ value, desc, id, onChange }) => <ShowTechTaskButton value={value} desc={desc} id={id}></ShowTechTaskButton>,
    TzPrice: ({ value, desc, id, onChange }) => <TzPrice value={value} desc={desc} id={id} onChangeValue={onChange}></TzPrice>,
    UploadQrButton: ({ value, desc }) => <UploadQrButton value={value} desc={desc}></UploadQrButton>,
    // @ts-ignore
    UploadQrButtonConsum: ({ value, desc }) => <UploadQrButton value={value} desc={desc} inmarket={'consum'}></UploadQrButton>,
    ProductCount: ({ value, desc, id, onChange }) => <ProductCount value={value} desc={desc} id={id} onChangeValue={onChange}></ProductCount>,
    ProductCountNoEdit: ({ value, desc, id, onChange }) => <ProductCount value={value} desc={desc} id={id} onChangeValue={onChange} editable={false}></ProductCount>,
    ProductCountFK: ({ value, desc, id, onChange }) => <ProductCount value={value} desc={desc} id={id} onChangeValue={onChange} fk={"count"}></ProductCount>,
    ProductCountWithUnitsType: ({ value, desc, id, onChange }) => <ProductCountWithUnitsType value={value} desc={desc} id={id} onChangeValue={onChange}></ProductCountWithUnitsType>,
    ProductCountWithUnitsTypeNoEdit: ({ value, desc, id, onChange }) => <ProductCountWithUnitsType value={value} desc={desc} id={id} onChangeValue={onChange} editable={false}></ProductCountWithUnitsType>,
    ProductCountAll: ({ value, desc, id, onChange }) => <ProductCount value={value} desc={desc} id={id} onChangeValue={onChange} fk={"all"}></ProductCount>,
    ProductCountDefect: ({ value, desc, id, onChange }) => <ProductCount value={value} desc={desc} id={id} onChangeValue={onChange} fk={"defect"}></ProductCount>,
    ProductCountSelfRet: ({ value, desc, id, onChange }) => <ProductCount value={value} desc={desc} id={id} onChangeValue={onChange} fk={"selfRet"}></ProductCount>,
    ProductCountEdit: ({ value, desc, id, onChange }) => <ProductCountEdit value={value} desc={desc} id={id} onChangeValue={onChange}></ProductCountEdit>,
    ProductCountEditFloat: ({ value, desc, id, onChange }) => <ProductCountEdit value={value} desc={desc} id={id} onChangeValue={onChange} float={true}></ProductCountEdit>,
    ProductCountEditKratCount: ({ value, desc, id, onChange }) => <ProductCountEditKratCount value={value} desc={desc} id={id} onChangeValue={onChange}></ProductCountEditKratCount>,
    ProductDim: ({ value, desc}) => <ProductDim value={value} desc={desc}></ProductDim>,
    ProductDimEditable: ({ value, desc, id, onChange}) => <ProductDimEditable value={value} desc={desc} id={id} onChangeValue={onChange}></ProductDimEditable>,
    ProductAllCount: ({ value, desc}) => <ProductAllCount value={value} desc={desc}></ProductAllCount>,
    PackageFeatures: ({ value, desc}) => <PackageFeatures value={value} desc={desc}></PackageFeatures>,
    PackageTagsInfo: ({ value, desc}) => <PackageTagsInfo value={value} desc={desc}></PackageTagsInfo>,
    Product: ({ value, desc }) => <Product value={value} desc={desc}></Product>,
    ProductMoreInfo: ({ value, desc }) => <ProductMoreInfo value={value} ></ProductMoreInfo>,
    ProductMoreInfoProducts: ({ value, desc }) => <ProductMoreInfoProducts value={value}/>,
    BigDisignNumber: ({ value}) => <BigDisignNumber value={value}></BigDisignNumber>,
    Consumable: ({ value, desc }) => <Consumable value={value} desc={desc}></Consumable>,
    HowMove: ({ value, desc }) => <HowMove value={value} desc={desc}></HowMove>,
    HowMoveInfo: ({ value, desc }) => <HowMoveInfo value={value} desc={desc}></HowMoveInfo>,
    ProductSize: ({ value, desc }) => <ProductSize value={value} desc={desc}></ProductSize>,
    ProductStocksTable: ({ value, desc }) => <ProductStocksTable value={value} desc={desc}></ProductStocksTable>,
    ProductStocksTableBig: ({ value, desc }) => <ProductStocksTableBig value={value} desc={desc}></ProductStocksTableBig>,
    DealProductsAllInfo: ({ value, desc }) => <DealProductsAllInfo value={value} desc={desc}></DealProductsAllInfo>,
    DealProductsAllInfoCons: ({ value, desc }) => <DealProductsAllInfo value={value} desc={desc} noRemains={true}></DealProductsAllInfo>,
    DealProductsAllInfoFBS: ({ value, desc }) => <DealProductsAllInfo value={value} desc={desc} noEtimated={true} noRemains={true}></DealProductsAllInfo>,
    DealProducts: ({ value, desc }) => <DealProducts value={value} desc={desc}></DealProducts>,
    DealProductsSizes: ({ value, desc }) => <DealProductsSizes value={value} desc={desc}></DealProductsSizes>,
    DealProductsCount: ({ value, desc }) => <DealProductsCount value={value} desc={desc}></DealProductsCount>,
    ImageBuffer: ({ value, desc }) => <ImageBuffer value={value} desc={desc}></ImageBuffer>,
    UsedQRForCli: ({ value, desc }) => <UsedQRForCli value={value} desc={desc}></UsedQRForCli>,
    RTImage: ({ value, desc }) => <RTImage value={value} ></RTImage>,
    PdfFile: ({ value, desc, onClickRow}) => <PdfFile value={value} desc={desc} onClickRow={onClickRow}></PdfFile>,
    Service: ({ value, desc }) => <Service value={value} desc={desc}></Service>,
    StatusDeal: ({ value, desc }) => <StatusDeal value={value} desc={desc}></StatusDeal>,
    StatusPay: ({ value, desc }) => <StatusPay value={value} desc={desc}></StatusPay>,
    StatusPayChanged: ({ value, onChange }) => <StatusPayChanged value={value} onChange={onChange}></StatusPayChanged>,
    DefaultTypography: ({ value }) => <DefaultTypography value={value}></DefaultTypography>,
    DefaultTypographyMid: ({ value }) => <DefaultTypographyMid value={value}></DefaultTypographyMid>,
    DefaultTypographyShort: ({ value }) => <DefaultTypographyShort value={value}></DefaultTypographyShort>,
    PrintedQrCount: ({ value }) => <PrintedQrCount value={value}></PrintedQrCount>,
    ConsumType: ({ value }) => <ConsumType value={value}></ConsumType>,
    // InputTestValueformat: ({ val, func, index }) => <InputTestValueformat val={val} func={func} index={index}></InputTestValueformat>,
    qrCodeFormat: ({ value, desc, onChange }) => <QrCodeFormat value={value} desc={desc} onChange={onChange}></QrCodeFormat>,
    qrCodeFormatNoPrint: ({ value, desc, onChange }) => <QrCodeFormatNoPrint value={value} desc={desc} onChange={onChange}></QrCodeFormatNoPrint>,
    barCodeFormat: ({ value, desc }) => <BarCodeFormat value={value} desc={desc}></BarCodeFormat>,
    BarCode: ({ value }) => <BarCode value={value}></BarCode>,
    BarCodeChangable: ({ value, id, onChange}) => <BarCodeChangable value={value} id={id} onChangeValue={onChange}></BarCodeChangable>,
    BarcodeMappingCell: ({ value }) => <BarcodeMappingCell value={value}></BarcodeMappingCell>,
    selectFormat: ({ value, desc }) => <SelectFormat value={value} desc={desc}></SelectFormat>,
    moreTextFormat: ({ value }) => <MoreTextFormat value={value} ></MoreTextFormat>,
    imageFormatProduct: ({ value }) => <ImageFormatProduct value={value} ></ImageFormatProduct>,
    LittleImageFormatProduct: ({ value }) => <LittleImageFormatProduct value={value} ></LittleImageFormatProduct>,
    json: ({ value }) => <pre>{JSON.stringify(value, null, 2)}</pre>,
    money: ({value})=><Price value={value}></Price>,
    date: ({value})=><FormattedDate value={value}></FormattedDate>,
    ColorsList: ({value})=><ColorsList value={value}></ColorsList>,
    // movingGuide: ({value})=><MovingGuide value={value}></MovingGuide>,
    DealDetails: ({value})=><DealDetails value={value}></DealDetails>,
    TitledList:  ({value})=><TitledList value={value}></TitledList>,
    ConsumableCount:  ({value})=><ConsumableCount value={value}></ConsumableCount>,
    TableColumnFormat: ({value}) => <TableColumnFormat value={value}></TableColumnFormat>,
    ShowList: ({value}) => <ShowList value={value}></ShowList>,
    ShowTechTaskVersion: ({value}) => <ShowTechTaskVersion value={value}></ShowTechTaskVersion>,
    UserShort: ({value}) => <UserShort value={value}></UserShort>,
    MultiWayDelivery: ({value}) => <MultiWayDelivery value={value}/>,
    RCK: ({value}) => <RCK value={value}/>,
    StorageCount: ({value}) => <StorageCount value={value}/>,
    FBSDateWB: ({value}) => <FBSDateWB value={value}/>,
    fbsStatus: ({value}) => <FbsStatus value={value}/>,
    FBSDealStatus: ({value}) => <FBSDealStatus value={value}/>
};
